var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoaderSplashRed1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "7.91938cm",
    height: "9.84646cm",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 3549.87 4413.68",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Conte\\xFAdo_x0020_do_x0020_PowerClip"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_2608583901504"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M48.62 3320.87c-5.07,-7.23 -11.13,-12.51 -21.54,-13.77 -10.65,1.6 -15.88,8.62 -20.53,16.11 -8.43,13.66 -8.66,33.11 -1.03,43.27 8.36,11.39 21.76,11.79 33.63,0.91 3.01,-2.83 5.93,-5.85 8.61,-9.13 9.47,-11.86 9.75,-24.78 0.86,-37.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M309.07 3344.86c-1,2.46 -0.27,6.16 0.98,11.98 2.31,3.72 3.13,5 4.21,5.58 14.27,7.72 20.82,6.27 24.47,-5.2 3.8,-12.09 0.83,-24.29 -6.86,-28.12 -9.16,-4.54 -16.11,0 -22.81,15.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2099.22 1745.61c-10.52,13.34 -22.61,7.33 -33.79,4.86 -23.4,-5.09 -43.16,3.48 -61.11,21.71 -4.67,4.71 -9.28,9.57 -13.96,14.27 -3.42,3.42 -7.32,3.47 -12.68,0.61 -0.08,-0.07 -0.15,-0.08 -0.21,-0.13 0.46,-0.12 0.97,-0.21 1.48,-0.43 -3.9,-7.31 -7.9,-9.63 -11.05,-2.72 -1.23,0.04 -2.52,0.18 -3.99,0.3 -6.32,0.7 -10.5,0.85 -16.51,0.93 -0.16,0.01 -0.29,0.09 -0.45,0.1 0.43,-0.43 0.89,-0.83 1.25,-1.31 -5.29,-2.47 -9.6,-2.9 -10.84,3.51 -1.16,0.27 -2.38,0.54 -3.75,0.76 -4.25,-0.56 -6.69,-0.88 -10.87,-0.74 -0.11,0.02 -0.21,0.09 -0.33,0.13 0.39,-0.68 0.78,-1.27 1.09,-2.01 -6.58,-2.05 -9.41,1.66 -9.59,7.6 -1,1.21 -2.04,2.55 -3.03,4.29 -5.96,10.49 -3.24,19.87 -1.94,27.93 1.92,11.78 4.03,21.96 -5.33,30.23 -1.05,0.92 -0.36,7.82 1.18,10.23 2.58,3.96 6.63,5.19 10.65,1.79 4.63,-3.97 7.91,-12.83 15.2,-7.23 5.55,4.15 7.92,11.1 9.17,18.85 0.97,6.25 2.89,12.47 3.03,18.69 0.43,14.36 4.9,24.5 15.95,29.03 6.81,2.77 10.17,9.22 8.65,17.49 -5.91,32.48 6.63,58.98 16.2,86.68 4.21,12.23 12.26,16.39 21.3,18.33 4.82,0.98 9.96,-0.53 14.99,-0.49 8.32,0.1 14.98,2.99 20.31,12.83 9.57,17.81 20.03,34.4 38.93,38.59 6.85,1.47 10.43,11.92 8.88,21.82 -2.12,13.5 -8.42,26.87 -2.25,40.68 5.94,13.11 18.86,13.5 27.72,21.85 8.14,7.75 15.44,1.49 14.94,-11.83 -0.28,-7.5 -1.81,-14.97 -2.97,-22.46 -5.07,-32.64 6.22,-63.21 29.3,-79.45 4.36,-3.07 8.44,-6.84 12.82,-9.85 12.51,-8.55 25.06,-15.81 40.02,-8.79 9.95,4.63 17.62,-1.93 22.69,-12.76 2.99,-6.49 5.31,-13.69 7.44,-20.7 1.53,-5.11 1,-11.64 -2.66,-13.68 -13.62,-7.75 -10.26,-26.44 -16.52,-38.77 -5.42,-10.63 -5.06,-21.69 0.84,-32.23 8.39,-15.17 6.08,-32.01 3.45,-48.08 -2.41,-14.83 -7.02,-29.02 -15.11,-43.35 0.3,-0.05 0.58,-0.09 0.93,-0.19 3.68,-3.94 6.26,-5.85 9.05,-6.67 5.15,-1.56 8.97,-4.37 9.42,-11.86 0.39,-8.07 -2.07,-14.44 -7.17,-19.12 -5.85,-5.37 -14.64,-3.07 -17.28,5.12 -2.25,6.94 -1.84,15.47 -6.51,21.91 -1.39,-0.43 -2.8,-0.83 -4.37,-1.2 -13.37,-10.97 -24.82,-20.82 -37.65,-32.2 -0.17,-0.14 -0.31,-0.25 -0.48,-0.45 0.58,0.04 1.15,0.13 1.72,0.1 -2.61,-7.52 -5.83,-11.06 -9.9,-6.11 -1.2,-0.47 -2.56,-0.85 -4.06,-1.21 -7.28,-1.99 -10.56,-6.31 -13.62,-11.63 -5.89,-10.18 -12.27,-19.94 -18.58,-29.71 -2.62,-3.98 -6.61,-8.26 -10.02,-3.85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1481.42 3259.33c-3,-16.04 -6.5,-32.23 -7.51,-48.62 -1.04,-17.88 -7.35,-32.42 -15.76,-44.61 -13.13,-19.06 -27.88,-36.3 -45.83,-48.83 -16.48,-11.5 -32.75,-9.43 -49.34,-3.49 -8.66,3.12 -16.62,9.38 -25.31,11.77 -17.45,4.89 -28.07,20.25 -35.35,38.42 -5.78,14.4 -11.17,29.89 -12.73,46.74 -2.17,23.99 -5.13,47.92 -7.67,75.01 1.58,37.53 16.15,65.38 27.81,95.08 8.32,21.25 21.72,33.17 37.65,41.41 11.03,5.7 22.71,9.64 34.02,14.62 15.37,6.81 31.55,5.59 44.31,-11.48 7.57,-10.09 15,-20.71 23.82,-28.85 26.65,-24.85 37.79,-57.63 35.18,-99.29 -0.78,-12.7 -0.93,-25.36 -3.28,-37.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1034.38 3467.87c-1.34,9.51 -2.73,15.79 -2.8,22.09 -1.02,36 2.91,69.54 21.14,99.96 11.7,19.57 26.83,27.09 43.07,36.99 16.81,10.25 30.42,8.57 45.22,-1.55 9.67,-6.63 19.44,-13.12 28.56,-20.84 7.05,-5.99 14.48,-13.28 17,-23.69 4.64,-19.09 10.59,-37.9 11.51,-58.34 1.93,-44.51 -3.51,-86.38 -27.72,-120.92 -22.02,-31.35 -52.47,-40.77 -86.87,-19.55 -27.24,16.78 -41.39,46.49 -49.11,85.85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1484.66 2203.79c-10.04,19.7 -15.53,44.3 -8.58,69.56 2.27,8.34 3.49,17.24 5,25.87 4.66,26.25 10.84,51.57 26.31,71.48 1.98,2.64 4.44,6.36 4.35,9.5 -0.22,7.83 0.56,11.56 7.63,8.45 2.6,-1.09 6.14,-0.43 8.8,0.92 26.82,13.2 48.05,1 68.29,-21.49 7.8,-8.73 14.03,-17.51 18.23,-29.43 5.95,-16.8 8.27,-34.08 6.02,-52.22 -2.19,-17.93 -1.29,-35.42 2.18,-53.03 1.63,-8.54 1.33,-17.71 1.34,-29.46 -0.11,-0.62 -0.31,-1.12 -0.45,-1.71 0.56,0.5 1.1,1.07 1.68,1.52 1.3,-8.59 2.1,-14.64 2.24,-21.86 0.91,0.22 1.87,0.36 2.95,0.49 13.66,6.91 18.99,-7.71 32.57,-10.95 -9.35,-5.82 -13.09,-11.47 -16.2,-17.79 -5.09,-10.37 -12.43,-18.83 -21.71,-15.44 -8.47,3.11 -7.16,15.64 -8.81,27.56 -0.52,-0.48 -0.99,-0.94 -1.54,-1.43 -9.2,-0.4 -17.44,-5.11 -20.45,7.45 -1.47,0 -2.85,-0.08 -4.4,0.07 -6.17,0.08 -10.48,0.6 -14.01,-1.31 -14.57,-8.08 -29.76,-5.34 -44.58,-3.98 -20.35,1.87 -36.75,17.41 -46.85,37.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2518.03 1318.41c0.14,-0.06 0.26,-0.05 0.4,-0.09 -0.94,-6.56 -3.1,-9.61 -6.47,-8.84 -1.11,-0.92 -2.32,-1.78 -3.72,-2.72 -5.26,-6.5 -9.28,-11.04 -15.22,-17.77 -0.37,-0.21 -0.7,-0.48 -1.05,-0.76 0.82,0.08 1.65,0.24 2.48,0.23 -5.5,-11.78 -14.99,-9.82 -21.12,-16.02 -3.29,-3.26 -3.35,-8.41 0.72,-11.39 1.68,-1.21 3.85,-1.37 5.53,-2.57 12.44,-9.39 13.12,-19.1 2.35,-32.35 -3.77,-4.63 -7.71,-8.03 -13.06,-4.42 -5.59,3.85 -9.43,9.27 -8.81,17.88 0.47,7.28 5.09,14.66 1.21,21.59 -4.76,8.48 -12.55,4.55 -19.18,5.29 -2.92,0.29 -6.14,-0.48 -8.69,0.88 -3.68,1.94 -5.88,5.74 -2.27,11.11 -1,0.85 -1.96,1.63 -2.94,2.58 -3.11,4.99 -5.21,8.34 -9.39,12.44l0 0.02c0.05,-0.58 0.22,-1.13 0.22,-1.71 -7.22,-4.01 -12.42,-7.41 -17.95,-9.92 -1.19,-0.49 -3.99,1.4 -4.79,3.13 -0.87,1.86 -1.09,6.01 -0.11,7.1 4.6,5.17 9.6,9.69 15.44,13.14 -0.12,1.78 0.01,3.81 0.42,6.24 -0.96,10.91 -2.54,18.49 -2.38,25.99 0.52,19.14 -4.38,33.44 -17.41,44.94 -10.34,9.15 -10.74,20.11 -3.51,33.03 5.12,9.28 10.98,18.32 17.82,25.47 12.43,13.1 28.26,13.62 41.28,1.28 8.7,-8.25 19.28,-13.82 25.55,-25.81 3.68,-7 9.2,-8.89 14.98,-11.35 11.87,-5.15 23.41,-4.41 35.33,-0.4 7.32,2.43 10.62,-1.78 12.15,-11.64 4.32,-28.15 0.01,-52.9 -17.81,-74.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2979.46 631.52c14.26,6.95 27.42,15.51 45.06,5.92 17.92,-9.75 38.17,-12.29 52.84,-31.26 1.8,-2.35 5.78,-1.72 8.54,-3.18 5.57,-2.85 11.28,-5.46 16.4,-9.35 10.09,-7.62 15.78,-19.74 15.69,-34.4 -0.12,-12.58 -11.17,-12.92 -16.89,-19.45 -4.92,-5.58 -11.35,-3.66 -19.37,-5.39 -13.74,-9.7 -24.87,-3.81 -32.42,5.8 -8.81,10.95 -17.49,11.54 -27.08,6.55 -12,-6.33 -23.82,-2.77 -35.53,-1.06 -25.17,3.67 -39.06,44.7 -23.59,69.54 4.2,6.73 10.11,13.25 16.35,16.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1778.34 1891.88c-5.2,11.13 -8.81,22.11 -6.61,36.09 2.78,17.43 1.86,17.6 -12.88,17.51 -3.99,-0.07 -8.06,-0.38 -11.98,0.26 -13.58,2.27 -20.82,13.59 -21.63,30.92 -1.1,22.91 10.27,37.25 20.97,52.17 2.86,4.03 7.37,2.85 11.44,2.23 20.46,-3.16 33.54,-29.6 27.65,-56.81 -1.79,-8.14 -12.09,-15.25 -7.04,-22.89 7.31,-11.04 13.21,5.7 20.69,6.28 5.97,0.42 11.84,1.64 19.81,2.2 0.14,-0.09 0.28,-0.13 0.4,-0.17 -0.06,0.46 -0.17,0.8 -0.24,1.31 11.65,5.95 21.21,11.19 31.63,14.14 -0.07,1.63 0.06,3.33 0.32,5.31 0.98,11.9 5.52,18.62 9.62,25.81 2.73,4.79 5.93,6.29 10.11,4.82 4.12,-1.34 6.71,-5.36 8.22,-10.07 3.15,-10.05 2.26,-19.71 -2.3,-28.85 -4.92,-9.74 -11.94,-12.41 -22.39,-7.67 -0.01,-1 -0.05,-2.02 -0.26,-3.13 -7.07,-5.12 -8.77,-11.87 -11.68,-18.32 0.49,-1.45 0.95,-2.9 1.29,-4.71 -0.46,-4.91 -0.26,-8.56 -1.45,-9.61 -13.28,-11.5 -23.04,-26.34 -30.36,-44.53 -2.23,-5.5 -7.73,-7.08 -13.26,-6.45 -8.45,0.99 -15.52,4.37 -20.06,14.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1783.6 3130.56c-6.89,-6.99 -14.52,-8.86 -21.87,-1.61 -8.1,8.01 -16.93,13.17 -29.24,15.09 -8.29,4.85 -11.9,12.21 -7.62,19.13 6.97,11.53 10.44,24.19 12.41,38.02 2.08,14.68 9.8,24.08 18.22,33.48 11.8,13.25 31.63,5.67 39.22,-9.07 16.3,-31.61 11.72,-71.77 -11.12,-95.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2177.31 2324.25c-3.86,0.14 -6.65,8.32 -3.78,11.58 7.79,8.9 10.44,20.04 12.79,32.65 2.62,14.9 10.34,27.06 20.13,36.59 9.97,9.69 20.85,5.59 31.52,3.58 10.32,-2.06 10.07,-13.97 13.23,-25.63 2.28,-9.96 3.18,-17.36 -0.74,-24.14 -4.71,-8.15 -9.46,-16.22 -13.91,-24.6 -11.25,-21.07 -21.92,-26.25 -39.7,-15.35 -6.71,4.12 -12.68,5.16 -19.53,5.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2337.51 2321.19c-15.72,-8.53 -25.36,-28.5 -44.18,-35.59 -23.78,4.06 -30.18,10.32 -28.65,29.85 1.97,24.92 10.97,45.7 28.74,58.56 7.91,5.74 33.83,2.33 39.97,-5.03 1.97,-2.34 3.25,-6.16 4.09,-9.6 1.83,-7.23 3.11,-14.57 4.69,-21.89 1.49,-6.9 0.17,-13.63 -4.66,-16.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2844.35 960.23c-1.99,4.23 -2.53,10.11 -6.93,11.52 -7.67,2.4 -16.64,1.9 -20.17,13.3 -4.23,13.85 -15.8,8.14 -22.81,15.13 -11.54,11.48 -11.2,33.13 2.12,40.56 8.87,4.89 19.04,6.09 25.08,17.42 16.11,3.63 6.74,-21.57 17.51,-24.83 3.52,-1 5.99,-7.16 9.53,-8.85 8.41,-4.02 13.6,-9.33 11.39,-22.24 -0.91,-5.53 2.93,-9.56 6.87,-10.74 5.8,-1.87 11.89,-2.23 18.24,-9.35 1.73,-3.38 2.25,-4.61 2.18,-5.82 0.17,-18.91 -12.41,-21.22 -22.09,-25.48 -7.75,-3.42 -16.06,-0.87 -20.92,9.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1966.57 1582.44c1.35,4.95 3.13,8.93 5.3,11.71 0.14,-5.42 -1.85,-9.27 -5.3,-11.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1971.9 1594.39c-0.26,6.08 1.47,9.24 5.86,10.89 8.2,3.02 11.35,9.81 8.23,20.16 -2.28,7.62 -3.44,15.42 1.73,21.07 8.04,8.77 11.57,25.38 24.38,25.72 13.3,0.35 26.51,5.77 40.84,0.13 0.43,1.18 0.88,2.34 1.37,3.64 8.79,11.32 15.66,22.38 30.04,26.63 -3.82,-16.15 -7.06,-30.28 -1.25,-45.29 4.23,-10.92 -6.3,-22.42 -15.62,-17.37 -6.25,3.36 -11.88,8.92 -17.61,15.26 -0.85,-0.82 -1.84,-1.61 -3.01,-2.36 -1.2,-15.35 -6.31,-27.75 -2.36,-43.02 0.14,0.36 0.3,0.78 0.49,1.16 6.28,-9.45 6.5,-10.44 -0.47,-11.87 -0.65,-1.32 -1.47,-2.63 -2.76,-3.94 -6.08,-4.33 -11.18,-6.1 -15.89,-14.24 -0.08,-0.04 -0.16,-0.07 -0.24,-0.13 0.84,-0.19 1.67,-0.34 2.5,-0.69 0.71,-11.65 -1.41,-19.63 -5.17,-27 -2.74,-5.53 -3.34,-11.37 -3.72,-18.5 -2.59,-1.51 -3.4,-2.28 -4.25,-2.93 -7.32,-5.86 -13.3,-3.08 -17.59,5.41 -2.99,6.02 -1.13,12.13 2.9,16.57 5.98,6.6 10.42,13.87 11.27,24.96 -1.35,0.56 -2.73,1.33 -4.18,2.34 -7.85,6.4 -13.21,12.43 -19.42,16.03 -6.42,3.64 -11.94,2.46 -16.09,-2.86 0.02,0.08 0.03,0.16 0.03,0.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1966.29 1577.45c-0.96,-5.64 -3.71,-9.61 -7.36,-4.15 -2.38,3.51 1.84,6.23 4.6,7.4 1.11,0.44 2.1,1.1 3.04,1.75 -0.13,-0.44 -0.27,-0.81 -0.4,-1.28 -0.3,-1.06 0.31,-2.56 0.12,-3.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2346.12 938.61c-5.84,4.88 -11.52,9.46 -17.95,13.15 -6.97,4.06 -6.71,16.38 0.06,21.84 6.62,5.37 13.84,8.3 19.35,17.04 11.82,18.73 27.16,24.56 46.8,10.46 6.44,-3.71 11.99,-5.54 11.16,-13.8 -0.85,-8.74 -2.86,-17.34 -3.45,-26.12 -1.08,-16.65 -1.8,-14.12 -16.72,-23.49 -14.33,-9.05 -26.72,-9.61 -39.25,0.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1556.83 823.09c15.5,-8.43 22.42,-37 14.03,-55.22 -3.53,-7.54 -8.45,-14.12 -17.35,-18.3 -16.66,-6.36 -30.17,-5.15 -39.02,12.85 -7.54,15.28 -6.17,31.39 0.74,46.84 9.38,20.97 24.92,22.9 41.6,13.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2105.59 4194.24c-9.35,1.32 -17.21,11.62 -18.76,26.34 -0.78,7.39 -0.4,15.33 0.89,22.61 1.97,11.13 5.32,21.86 9.25,35.04 2.68,3.97 3.89,6.3 5.57,7.46 14.81,10.37 21.94,8.11 29.23,-9.03 9.57,-22.24 7.69,-44.73 -0.91,-65.94 -4.78,-11.7 -14.04,-18.07 -25.26,-16.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2113.41 2947.61c2.77,-17.56 -6.16,-28.76 -13.3,-40.71 -11.15,-18.51 -20.59,-20.83 -36.33,-10.36 -9.99,6.66 -13.55,17.21 -11.13,31.96 3.07,18.93 11.45,32.23 27,41.59 8.94,6.47 15.85,9.82 24.18,3.76 8.71,-6.26 8.04,-16.39 9.57,-26.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2499.13 1874.84c0.22,-3.71 -0.15,-7.55 -0.37,-11.36 -0.47,-8.67 3.45,-10.65 9.23,-9.96 21.81,2.55 22.52,2.12 18.57,-23.52 -1.21,-7.91 -0.97,-15.06 0.15,-22.37 1.99,-12.89 -9.55,-18.85 -9.31,-30.74 -6.84,-3.09 -13.02,-9.62 -21.41,-6.97 1.29,2.67 1.76,5.62 3.13,6.5 6.62,4.37 12.59,8.45 7.29,20.01 -1.99,4.27 -2.66,9.47 -4.13,14.14 -4.87,15.5 -9.55,30.67 -26.32,30.44 -4.77,-0.07 -8.53,6 -11.48,13.43 -0.39,0.35 -0.67,0.66 -0.99,0.92 -8.96,3.74 -13.29,-2.47 -18.66,-5.04 -10.92,-5.26 -13.59,-3.46 -20.26,12.19 -0.95,2.19 -1.4,4.68 -0.36,8.4 2.43,2.3 3.07,3.26 3.8,4.11 18.84,21.09 22.04,20.75 35.52,-4.36 0.01,-0.12 -0.04,-0.5 -0.21,-1.34 -0.06,-0.26 -0.11,-0.47 -0.21,-0.71 0.36,0.54 0.66,1.07 1.15,1.77 4.59,6.22 6.51,9.24 7.91,12.61 3.54,8.19 8.15,16.2 16.09,12.98 6.93,-2.88 10.32,-11.59 10.86,-21.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2626 799.66c3.44,6.42 6.79,12.64 11.23,20.94 24.84,22.95 24.84,22.87 54.7,24.71 1.84,0.13 3.99,2.86 5.35,2.21 3.68,-1.89 0.13,-2.06 -0.63,-2.7 -12.93,-11.38 1.42,-19.88 1.9,-29.57 1,-19.75 0.13,-23.21 -14.1,-32.29 -9.52,-6.15 -18.76,-7.87 -28.49,-2.38 -5.41,3.02 -10.98,6.07 -15.82,10.33 -4.47,3.93 -12.83,-2.41 -14.14,8.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2270.76 1019.16c3.96,4.58 8.03,7.7 13.26,5.02 13.45,-6.67 17.4,-30.97 7.27,-43.4 -3.68,-4.63 -7.82,-7.7 -12.95,-8.6 -10.77,-1.91 -21.52,-5.37 -32.23,-5.23 -7.44,0.09 -11.03,-2.84 -13.71,-10.46 -0.39,-1.13 -1.09,-2.17 -1.8,-2.94 -5.31,-5.76 -11.48,-4.69 -15.18,2.6 -3.2,6.31 -2.45,12.52 1.89,16.8 3.61,3.7 11.58,1.98 12.22,8.6 1.39,14.25 7.6,29.34 -0.18,44.89 -0.89,0.09 -1.8,0.21 -2.78,0.44 -2.17,5.46 -2.95,9.07 -4.16,12.53 -1.86,5.62 -5.07,11.35 0.48,16.28 4.76,4.24 9.3,1.93 13.38,-2.05 7.13,-6.76 10.16,-15.02 4.01,-26.13 -0.1,-0 -0.14,-0.01 -0.2,-0.01 0.74,-0.84 1.53,-1.83 2.3,-3.13 9.2,-14.76 18.6,-16.56 28.39,-5.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1819.47 723.78c5.24,1.34 9.8,0.43 12.27,-6.9 1.53,-4.65 2.86,-10 5.55,-13.28 8.69,-10.52 5.04,-20.75 -0.06,-30.53 -5.06,-9.76 -12.6,-16.31 -20.88,-21.05 -11.91,-6.61 -19.49,-2.34 -27.43,11.94 -5.8,10.43 -6.18,21.03 -3.78,35.09 10,14.57 21.49,21.46 34.33,24.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2308.03 2038.48c-3,14.57 -1.1,27.15 7.39,38.5 12.95,17.37 18.56,18.69 44.01,5.72 4.32,-5.19 7.26,-10 5.6,-14.71 -4.16,-11.39 -8.86,-22.69 -14.43,-33.04 -4.62,-8.43 -12.08,-13.11 -20.07,-15.21 -10.07,-2.56 -19.83,5.92 -22.49,18.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2286.93 2639.27c4.29,-18.7 -7.9,-51.56 -21.53,-61.51 -5.43,-3.99 -10.87,-5.98 -16.69,-1.56 -7.41,5.48 -11.48,15.21 -9.96,25.28 2.82,19.23 8.52,36.2 22.52,46.66 0.05,0.18 0.1,0.39 0.15,0.6 -0.06,0.12 -0.16,0.17 -0.25,0.31 -5.45,21.79 -4.8,29.11 0.46,26.83 8.96,-4.02 4.55,-14.27 5.99,-21.83 0.02,-0.08 -0.01,-0.18 0.01,-0.26 0.59,-0.6 1.25,-1.34 1.95,-2.52 10.59,3.68 15.43,-3.51 17.34,-12.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2521.24 1663.88c-3.45,5.1 -5.16,11.08 -4.42,17.5 2.6,22.84 29.01,39.35 44.48,28.2 5.85,-4.26 9.38,-14.41 8.25,-22.64 -2.08,-15.55 -15.17,-22.95 -17.63,-38.47 -0.31,-1.69 -7.46,0.54 -10.1,-1.78 -7.28,6.52 -15.14,9.08 -20.57,17.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2039.66 1255.69c10.6,11.78 22.67,20.59 36.34,24.9 7.29,2.35 15.82,-4.4 19.73,-13.07 4,-8.89 2.42,-16.82 -1.91,-24.63 -6.06,-11.12 -13.48,-18.39 -26.84,-16.09 -5.74,-1.55 -9.33,-3.85 -13.25,-4.94 -5.89,-1.53 -11.99,-1.96 -15.86,5.89 -4.3,8.74 -3.89,21.65 1.78,27.94z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1889.18 1234.71c-0.49,3.52 -0.36,7.54 0.39,11.09 2.11,10.28 13.56,17.76 24.51,16.35 9.41,-1.25 17.96,-10.33 18.57,-20.66 0.62,-11.55 -0.3,-22.8 -9.03,-33.63 -5.59,-8.88 -11.57,-9.52 -17.5,-10.35 -7.02,-1 -11.12,2.23 -12.39,11.55 -1.16,8.65 -3.27,17.03 -4.53,25.65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1750.15 1814.99c3.01,-2.15 2.82,-9.34 1.1,-14.23 -2.27,-6.41 -7.09,-9.85 -12.05,-8.84 -10.57,2.28 -21.06,5.73 -31.37,9.61 -2.3,0.81 -4.59,4.96 -5.4,8.25 -2.2,8.75 -1.12,17.54 1.88,25.81 2.79,7.88 8.27,10.29 16.4,11.68 14.1,-6.78 18.18,-24.27 29.45,-32.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2557.79 1308.76c-0.17,8.96 5.15,12.83 11.17,15.14 6.84,2.6 13.68,2.42 22.28,-1.53 9.29,-8.92 9.71,-17.19 4.94,-27.67 -7.94,-17.51 -25.08,-18.8 -34.84,-33.04 -0.55,-0.83 -3.71,0.68 -5.4,1.69 -3.18,1.84 -4.56,6.5 -3.28,9.35 5.03,11.41 5.3,23.56 5.13,36.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2098.45 2426c-0.6,-9.34 -6.77,-17.89 -16.46,-18.39 -9.37,-0.45 -16.93,-2.54 -24.37,-10.7 -5.14,-5.67 -10.8,-0.66 -15.95,7.51 -0.11,-0.74 -0.16,-1.47 -0.36,-2.3 -3.28,-7.74 -4.18,-13.95 -6.27,-19.37 -3.12,-7.7 -10.15,-9.96 -14.82,-5.76 -4.85,4.36 -7.26,15.99 -2.94,19.56 8,6.79 12.27,19.53 22.35,21.42 0.75,1.12 1.79,2.3 3.23,3.42 12.08,5.35 17.24,16.92 24.24,25.76 3.71,4.68 8.3,7.3 13.53,6.03 9.54,-2.31 18.55,-16.37 17.81,-27.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M638.52 3202.05c-2.07,-2.5 -4.82,-4.4 -7.49,-5.69 -6.04,-2.88 -11.65,-1.15 -18.35,5.05 -7.7,7.33 -9.72,15.28 -9.49,24.67 0.13,10.25 0.13,21.16 8.18,26.5 8.96,5.98 17.42,0.56 24.85,-6.05 8.38,-7.54 9.66,-35.57 2.31,-44.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2278.44 540.03c15.86,26.07 16.79,25.99 31.07,19.09 9.21,-4.42 10.23,-14.21 12.78,-23.34 4.52,-16.21 3.18,-19.49 -9.31,-24.27 -20.95,-8.07 -29.06,-2.07 -34.54,28.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2183.92 1342.62c-7.36,-0.67 -18.72,11.56 -19.5,19.9 -1.13,11.67 8.87,31.25 18.29,36.03 11.56,5.79 17.13,1.35 24.3,-12.01 5.51,-10.34 -0.67,-22.6 3.31,-31.54 -8.45,-10.17 -17.52,-11.57 -26.4,-12.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1042.38 2708.03c1.9,11.06 8.83,18.39 18.87,19.86 6.21,0.87 11.32,-4.52 15.07,-14.88 3.88,-10.79 4.85,-21.55 -0.22,-34.85 -7.64,-8.56 -14,-15.21 -22.5,-8.71 -9.13,7 -14.25,16.85 -12.1,31.14 0.36,2.45 0.44,4.99 0.88,7.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1987.71 870.8c8.23,4.84 16.15,2.35 24.36,-7.69 7.34,-8.99 8.87,-15.63 4.69,-27.2 -3.26,-9.12 -7.65,-17.63 -11.66,-26.7 -4.85,4.95 -8.96,8.29 -16.09,9.17 -8.23,6.13 -10.82,14.56 -11.94,23.37 -1.51,11.72 3.79,24.99 10.63,29.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2348.9 2718.33c-6.61,11.19 -10.31,21.12 -4.33,32.55 5.54,10.4 10.28,21.79 22.2,21.75 4.02,-0.04 8.73,0.36 10.1,-4.96 3.55,-13.21 5.69,-26.88 -0.74,-39.81 -6.12,-12.31 -14.96,-15.46 -27.23,-9.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M3292.57 1659.66c-2.82,9.44 -0.67,16.89 6.38,22.09 11.3,8.25 23.44,12.88 38.62,13.95 9.45,-3.35 10.78,-9.95 6.77,-17.5 -7.32,-14.08 -18.26,-22.72 -29.94,-29.92 -1.69,-1.07 -3.81,-1.22 -5.74,-1.61 -7,-1.13 -13.47,4.11 -16.09,12.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2513.61 314.09c13.07,-2.09 22.43,-9.74 27.22,-28.35 -0.47,-9.74 -4.83,-12.86 -9.29,-15.94 -12.18,-8.28 -22.12,-8.27 -30.38,0.92 -7.06,7.83 -5.15,18.64 -4.52,28.44 0.75,11.88 6.98,16.48 16.97,14.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M932.63 2606.3c0.7,1.99 2.69,3.84 4.4,4.72 10.04,5.13 26.74,0.26 29.99,-8.45 5.18,-13.83 -1.89,-33.84 -14.81,-40.11 -3.32,-1.58 -7.71,0.38 -13.47,1.89 -14.55,12.77 -11.31,27.28 -6.1,41.95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M3192 1357.33c15.53,4.69 31.43,9.56 46.04,-3.67 1.99,-1.85 4.07,-6.42 3.67,-9.06 -0.42,-2.97 -3.35,-6.16 -5.82,-7.66 -2.54,-1.54 -5.84,-1.13 -11.05,-1.8 -12.3,-4.98 -20.9,-15.95 -32.86,-12.75 -2.64,0.69 -5.96,2.68 -7.2,5.37 -4.11,8.96 0.22,27.53 7.22,29.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2185.37 1183.84c0.22,-0.13 0.43,-0.25 0.63,-0.36 -0.22,0.95 -0.46,2.01 -0.73,3.11 5.21,2.41 8.95,3.46 14.93,5.9 -0.45,0.15 -0.9,0.22 -1.3,0.39 5.31,5.79 10.01,9.47 12.39,1.92 1.05,-0.17 2.11,-0.49 3.15,-0.88 -0.01,-0.12 0.07,-0.1 -0.19,-1.97 0.67,0.38 1.35,0.7 2.04,0.98 3.22,-14.94 14.55,-15.66 20.6,-23.41 3.74,-4.71 6.72,-9.79 4.42,-16.51 -2.26,-6.6 -3.05,-15.37 -9.92,-17.46 -6.54,-1.91 -11.03,3.19 -15.39,8.71 -4.78,5.99 -1.85,17.72 -9.65,21.16 -6.83,-3.34 -13.11,-6.67 -19.57,-9.58 -3.2,-1.42 -6.27,0.38 -7.45,3.97 -3.1,9.55 -5.46,19.24 6.05,24.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M3181.29 1994.71c-12.96,0.2 -18.53,8.08 -19.52,20.68 -0.84,10.44 5.84,14.97 11.56,19.97 7.67,6.64 16.41,8.23 25.31,9.26 5.24,0.68 9.54,-2.27 12.33,-8.19 2.97,-6.35 0.72,-12 -1.71,-17.56 -5.68,-12.99 -15.54,-18.71 -27.98,-24.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2072.31 1184.06c8.84,-6.02 11.88,-19.19 7.27,-32.66 -1.14,-3.42 -3.45,-6.23 -6.58,-11.3 -6.83,-6.38 -12.6,-7.04 -18.55,-3.9 -10.52,5.41 -15.18,21.18 -10.68,35.16 3.51,10.8 20.39,18.37 28.55,12.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M3519.3 680.57c15.63,4.77 28.11,-1.96 30.36,-13.94 1.51,-7.83 -5.41,-19.74 -15.23,-25.26 -6.32,-3.55 -12.78,-6.51 -20.1,-4.84 -11.28,2.64 -16.5,16.15 -10.56,28.41 3.29,6.69 8.3,10.72 15.54,15.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M3142.14 323.57c10.74,7.35 21.2,4.99 29.54,-6.35 5.93,-7.96 5,-19.83 -1.72,-26.77 -7.57,-7.76 -16.5,-9.59 -25.34,-7.08 -8.38,2.42 -13.3,10.58 -13.27,24.7 2.3,8.98 6.38,12.68 10.78,15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1671.68 2982.26c8.86,-13.51 6.63,-35.99 -5.18,-46.43 -5.32,-4.79 -11.4,-4.7 -15.87,2.3 -2.39,3.86 -3.81,8.69 -5.98,15.61 -0.09,13.1 4.22,21.63 9.02,29.59 4.37,7.24 13.12,6.37 18.01,-1.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1452.57 2051.15c-8.55,-7.68 -21.16,-0.82 -23.17,12.27 -1.38,8.97 -0.24,17.58 1.41,26.25 1.34,7.2 -2.48,11.76 -1.82,15.5 14.59,-1.81 25.36,-0.95 30.85,-17.43 4.59,-13.64 2.64,-27.67 -7.27,-36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1928.5 2202c-4.64,-3.49 -12.17,-3.81 -13.38,1.34 -3.98,16.86 -18.33,11.84 -26.24,24.16 -1.78,7.34 -3.24,12.3 -2.85,17.2 0.61,10.48 6.77,14.64 14.12,16.11 4.9,1.01 12.12,1.31 13.17,-4.85 2.22,-12.93 3.63,-23.6 17.21,-17.19 0.99,0.53 3.53,-2.03 4.41,-3.85 5.32,-11.56 2.46,-26.04 -6.45,-32.92z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2068.32 2205.44c4.73,-6.61 4.94,-14.96 -0.13,-24.35 -2.79,-5.2 -6.02,-10.33 -9.85,-14.2 -12.21,-12.4 -25.58,-5.48 -28.42,14.63 -0.5,3.57 0.7,7.49 1.99,13.66 5.76,6.73 10.41,11.66 15.5,15.49 8.62,6.09 14.07,4.46 20.89,-5.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1962.82 2387.46c-1.04,-10.9 -5.15,-16.17 -10.56,-20.07 -16.98,-12.43 -22.88,-3.7 -26.15,17.86 -1.24,8.21 2.18,14.69 5.56,20.92 8.63,15.98 19.83,15.32 26.99,-1.73 1.82,-4.42 2.78,-9.41 4.16,-16.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2089.18 1078.19c2.53,-1.89 5.41,-3.09 7.7,-5.33 1.41,-1.39 2.67,-4.01 2.83,-6.26 0.75,-10.01 -12.48,-28.51 -20.76,-27.59 -9.18,1.01 -19.35,-0.31 -27.42,8.24 2.88,7.29 5.11,12.9 8.47,20.62 14.38,21.24 14.38,21.24 29.18,10.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1815.63 1117.86c5.95,-1.01 9.12,-7.18 8.89,-13.37 -0.37,-9.99 -2.69,-19.84 -4.33,-32.05 0.08,-4.56 0.93,-8.46 0.23,-9.08 -11.28,-9.48 -16.29,-7.43 -19.36,7.71 -2.78,13.57 -6.31,27.21 1.3,40.24 3.39,5.7 8.06,7.31 13.26,6.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2820.55 1427.88c-2.78,-4.92 -6.7,-9.56 -10.87,-12.31 -10.46,-6.79 -23.21,-3.52 -26.22,6.59 -4.08,13.95 2.95,20.92 13.5,26.95 5.83,1.3 9.79,3.03 13.63,2.64 10.75,-1.13 15.94,-13.39 9.97,-23.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1732.88 1261.43c3.76,0.52 6.9,2.24 7.45,1.49 6.8,-11.3 8.53,-23.99 5.35,-37.71 -2.47,-10.78 -9.59,-15.97 -18.13,-13.2 -12.18,3.94 -18.08,17.12 -13.58,31.53 3.02,9.46 7.64,17.59 18.91,17.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2186.93 2635.13c-4.2,-5.43 -6.93,-9.2 -10.28,-11.55 -8.57,-6.38 -15.84,-2.6 -17.83,8.53 -1.65,8.84 -1.26,17.73 3.28,24.85 5.5,8.51 10.89,18.47 21.52,16.07 6.76,-1.55 8.76,-10.17 6.8,-28.88 -0.19,-2.41 -1.48,-4.63 -3.48,-9.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2317.09 1485.12c1.61,6.78 2.02,10.84 3.47,13.89 6.99,13.92 19.78,18.67 30.67,11.78 5.99,-3.77 5.78,-13.77 -0.63,-30.8 -4.33,-11.65 -12.47,-16.02 -22,-10.51 -4.35,2.5 -7.88,7.52 -11.79,11.05 0.04,-0.31 -0.4,1.45 0.29,4.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2878.95 2459.61c-20.05,12.42 -21.21,19.67 -7.55,34.73 2.22,2.45 4.59,4.83 7.09,6.9 8.98,7.38 19.82,8.98 21.8,3.06 3.5,-10.12 1.39,-19.97 -3.07,-28.79 -3.86,-7.74 -9.08,-13.53 -18.27,-15.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2410.67 2975.79c3.88,0.01 7.82,-1.55 13.48,-3.6 9.03,-12.52 7.74,-24.64 3.33,-36.63 -2.99,-8.23 -10.15,-11.82 -17.51,-9.79 -7.06,1.88 -9.61,7.97 -9.63,16.36 -0.07,7.63 -0.56,15.24 -0.04,22.7 0.61,7.23 4.99,10.83 10.37,10.95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1411.64 2162.99c10.04,-9.65 12.6,-22.05 7.44,-36.37 -3.64,-10.16 -11.58,-14.88 -22.11,-12.13 -3.8,0.94 -7.35,3.65 -10.57,8.77 -1.34,10.35 -3.05,17.56 -4.68,24.85 -1.09,5.16 -0.27,9.56 3.14,13.3 8.82,9.58 17.65,10.2 26.77,1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2512.99 2493.9c-4.78,12.91 -0.11,21.5 4.3,29.53 6.41,11.56 16.41,15.25 22.65,9.58 5.58,-5.02 6.24,-14.81 1.83,-27.32 -5.86,-16.72 -11.7,-19.62 -28.78,-11.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2693.79 1257.74c-7.18,6.6 -13.2,13.92 -22.8,16.3 -9.87,2.41 -11.42,12.31 -5.55,23.29 2.91,5.6 6.75,9.27 14.16,8.76 12.57,-7.02 17.74,-23.63 31.41,-24.8 3.99,-0.28 4.53,-7.77 3.47,-12.89 -2.71,-13.01 -12.28,-18.36 -20.69,-10.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M931.97 478.95c7.37,-0.74 12.38,-7.39 12.92,-17.13 0.95,-17.89 -6.13,-24.52 -26.7,-22.18 -6.86,8.7 -6.78,17.31 -4.98,26.07 2.02,9.52 8.95,14.13 18.76,13.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1365.62 3513.3c-1.8,-0.59 -4.18,-0.75 -5.77,0.26 -8.91,5.78 -12.54,15.34 -11.28,30.24 3.54,7.32 6.2,12.67 9.8,16.76 6.06,7.22 13.5,4.8 16.14,-4.77 0.95,-3.51 2,-7.14 2.23,-10.8 1.26,-16.03 -3.24,-28.73 -11.12,-31.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1697.97 1892.29c-0.26,-10.16 -1.52,-20.08 -9.89,-25.4 -7.12,-4.46 -14.69,-0.72 -22.23,12.03 -1.59,2.7 -1.34,7.13 -1.47,13.46 2.76,10.59 8.45,13.39 13.84,16.3 11.05,5.83 20.1,-1.56 19.75,-16.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1569.68 980.03c-9.08,9.81 -25.25,10.79 -25.21,34.39 2.75,6.23 4.72,11.14 7.95,13.64 7.31,5.67 18.11,2.55 20.66,-5.93 3.55,-11.79 4.93,-24.28 3.21,-36.9 -0.53,-3.79 -4.52,-7.39 -6.61,-5.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2823.41 1661.03c1.5,-12.8 -4.97,-14.7 -12.63,-15.85 -12.41,-1.84 -17.75,0.19 -20.29,9.38 -0.95,3.36 -1.21,7.55 -0.5,10.98 1.96,9.87 8.64,13.47 15.46,16.07 7.25,2.76 13.97,2.51 17.94,-10.42 0.1,-5.07 -0.3,-7.73 0.02,-10.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1531.77 1674.06c3.69,7.35 6.29,13.12 10.18,16.63 6.71,6.06 13.51,4.29 18.53,-3.28 7.17,-10.86 4.83,-27.55 -5.11,-36.53 -6.84,-6.25 -16.57,-2.41 -22.43,9.49 -1.54,3 -1.2,7.32 -1.17,13.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1973.26 1749.48c15.49,-2.26 21.67,-18.54 13.01,-34.9 -2.06,-3.93 -5.83,-6.39 -10.79,-10.13 -12.93,-0.96 -18.13,6.77 -19.01,19.82 -0.81,12.52 8.68,26.41 16.8,25.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1734.97 2371.97c4.58,-3.94 5.58,-9.97 4.87,-16.39 -1.1,-9.8 -1.76,-20.14 -12.57,-26.42 -0.16,-0.06 -0.34,-0.13 -0.45,-0.22 0.52,-0.35 1.09,-0.69 1.62,-1.19 -6.9,-13.69 0.92,-24.87 -1.77,-36.19 -2.54,-10.36 -11.6,-15.5 -18.84,-9.03 -6.56,5.77 -8.44,14.3 -5.25,23.26 2.95,8.18 11.49,12.94 11.63,23.73 -1.19,0.97 -2.38,2.21 -3.55,3.91 -7.7,16.09 -4.09,27.96 5.02,38.03 4.7,5.28 13.69,5.37 19.3,0.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2680.63 1478.43c4.2,-6.09 2.46,-16.43 -5.65,-21.63 -7.8,-4.96 -14.44,-10.23 -18.43,-18.88 -0.1,-1.74 -0.26,-3.63 -0.49,-5.61 -6.07,-6.02 -11.26,-9.93 -17.95,-15.2l-0.04 -0.09c0.41,-0.16 0.82,-0.17 1.25,-0.43 -3.27,-5.31 -6.5,-8.62 -9.96,-5.93 -1.39,-0.55 -2.91,-1.07 -4.68,-1.49 -9.87,-2.61 -16.06,0.27 -20.42,8.45 -2.8,5.25 -4.73,11.02 -4.31,17.74 1.03,16.26 9.8,26.48 24.2,26.65 4.84,0.08 9.71,-2.34 16.81,-3.53 0.16,-0.01 0.26,-0.03 0.39,-0.08 -0.12,0.33 -0.31,0.55 -0.43,0.87 12.45,2.53 9.9,16.91 16.08,23.12 6.81,6.73 16.92,5.81 23.63,-3.96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1919.38 1593.57c-13.64,11.21 -13.28,36.67 0.71,46.69 5.61,4.08 11.57,1.84 18.41,-1.21 5.89,-9.95 8.78,-17.51 7.87,-27.1 -1.29,-14.35 -18.01,-25.79 -26.99,-18.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M3333.06 702.68c7.24,-3.48 14.44,-7.67 19.45,-15.88 2.36,-3.79 0.87,-7.45 -1.78,-8.93 -4.41,-2.48 -9.19,-3.89 -15.88,-6.32 -3.94,-0.89 -5.99,-1.8 -7.84,-1.39 -11.31,2.89 -15.41,8.32 -14.08,18.27 1.52,11.45 10.99,18.61 20.12,14.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2676.89 587.51c-3.19,3.79 -3.33,8.78 -1.32,13.83 2.34,5.95 6.21,9.68 12.91,12.81 6.45,-2.42 11.24,-4.56 15.08,-8.25 6.82,-6.8 10.37,-17.97 7.67,-22.52 -4.93,-8.27 -12.45,-6.7 -19.14,-6.76 -6.28,-0.06 -10.91,5.71 -15.2,10.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2463.58 1870.61l-0.04 0.04 0.02 0.1c-0,-0.02 0.02,-0.09 0.02,-0.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2463.56 1870.76c-0.03,0.05 -0,0.1 0,0l0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1872.8 1416.97c-9.37,2.43 -14.25,8.06 -17.15,16.67 -2.74,8.01 -1.25,14.4 5,18.72 3.43,2.31 6.96,4.65 10.72,5.93 6.08,2.07 11.76,0.74 15.8,-6.17 4.42,-7.54 6.19,-15.84 2.28,-24.41 -3.08,-6.84 -7.92,-10.96 -16.65,-10.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M3391.99 1497.7c7.61,-1.79 11.87,-10.97 9.41,-19.26 -3.09,-10.55 -9.81,-15.18 -17.51,-17.73 -6.34,-2.11 -11.34,1.65 -15.36,10.9 6.19,23.52 11.61,28.84 23.45,26.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M234.24 3304.86c2.24,0.77 6.09,-0.95 7.87,-3.23 5.55,-6.97 10.84,-14.52 15.46,-22.49 3.66,-6.41 4.66,-14.26 -0.17,-20.65 -5.89,-7.89 -12.09,-7.05 -19.01,3.03 -6.6,10.47 -4.9,21.27 -7.24,30.81 -1.15,4.68 -1.83,10.65 3.09,12.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2330.2 1872.9c10.98,2.02 16.92,-7.19 13.8,-19.93 -1.57,-6.29 -4.6,-10.74 -8.48,-14.69 -6.83,-6.86 -11.53,-5.53 -20.38,3.94 -8.06,8.7 -3.06,14.87 2.92,23.39 5,3.74 8.45,6.65 12.14,7.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2756.25 951.6c9.98,4.28 17.97,5.88 22.64,-5.97 3.91,-10 1.23,-22.42 -5.39,-27.15 -7.38,-5.3 -20.24,-2.93 -24.82,5.25 -1.55,2.85 -1.88,7.25 -1.88,10.85 0.04,6.95 3.74,11.55 9.44,17.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2819.67 1550.45c-2.61,7.78 -1.12,15.17 3.68,20.61 9.5,10.78 17.36,10.62 32.12,-2.13 -2.61,-16.3 -10.51,-23.22 -20.61,-27.02 -5.64,-2.08 -13.07,2.05 -15.2,8.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1978.02 1155.99c1.61,-8.83 -4.23,-17.74 -10.82,-19.28 -5.87,-1.3 -14.62,4.59 -16.53,12.04 -1.98,7.71 -0.35,14.38 4.59,20.12 4.74,5.57 10.26,6.52 16.17,6.98 0.92,0.07 1.59,0.37 2.12,0.79 0.73,-7.51 3.29,-13.9 4.47,-20.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1973.54 1176.65c-0.13,1.6 -0.24,3.31 -0.18,5.05 1.66,-1.24 1.86,-3.77 0.18,-5.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1960.29 995.49c-6.4,2.06 -10.15,7.85 -11.04,15.91 -1.05,9.91 3,16.89 9.57,21.41 6.56,4.52 11.15,-0.91 17.04,-7.59 3.68,-6.15 4.71,-11.26 3.19,-16.02 -3.52,-10.57 -11.31,-16.12 -18.77,-13.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2172.51 473.98c3.7,-0.2 7.32,-2.91 12.19,-6.7 1.81,-8.41 3.02,-14.59 2.76,-20.7 -0.12,-3.15 -2.21,-7.43 -4.42,-9.12 -6.61,-5.04 -13.52,-2.64 -19.86,1.29 -4.36,2.74 -6.58,15.65 -4.58,24.25 2.07,8.63 7.7,11.35 13.92,10.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2586.64 1050.48c-5.75,9.25 0.6,13.17 8.55,16.9 9.85,4.92 9.35,14.08 10.19,23.31 5.06,-6.85 9.81,-13.13 14.39,-19.53 2.95,-4.11 3.64,-9.16 1.92,-14.16 -7.11,-20.78 -24.05,-24.3 -35.05,-6.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2900 515.14c9.35,-2.28 18.22,-17.19 17.62,-27.45 -0.33,-5.7 -3.59,-9.17 -8,-9.66 -10.72,-1.12 -19.82,2.29 -25.27,18.02 0.51,14.72 6.16,21.35 15.65,19.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1805.01 2008.58c-5.04,7.36 -2.78,20.42 5.24,30.01 7.46,9 16.54,5.39 20.05,-8.26 0.89,-3.43 0.43,-7.52 0.01,-13.66 -13.17,-15.59 -19.24,-16.91 -25.3,-8.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2364.07 3602.34c-9.74,-4.85 -14.81,3.03 -17.86,16.6 0.63,14.66 6.84,20.69 15.08,23.36 5.1,1.64 10.22,-0.46 12.35,-7.45 3.7,-12.08 -0.65,-28.1 -9.57,-32.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2084.15 1327.14c3.28,9.25 3.27,17.28 -0.17,25.09 -1.43,0.55 -3,1.48 -4.8,3.14 -7.31,8.18 -13.02,14.9 -18.06,22.41 -18.43,27.42 -13.43,25.78 2.38,48.01 4.15,5.81 10.01,12 19.38,12.12 0.19,0.01 0.35,0.07 0.5,0.09 -0.07,0.38 -0.19,0.65 -0.24,1.06 7.81,4.54 13.24,7.8 12.25,17.64 -0.61,6.19 -2.14,12.39 -1.81,18.44 0.35,6.38 9.66,10.89 14.75,8.08 4.7,-2.63 4.45,-7.55 4.11,-12.76 -0.81,-14.13 -9.76,-23.07 -15.64,-35.69 0.67,-0.72 1.37,-1.54 2.05,-2.51 1.88,-4.34 2.68,-6.97 4.44,-12.8 0.24,-0.52 0.42,-1.04 0.62,-1.53 0.15,1.21 0.32,2.37 0.57,3.57 7.56,-9.2 13.2,-12.06 22.45,-10 11.22,2.63 15.76,-6.58 12.87,-20.61 -2.21,-10.73 -7,-14.29 -15.09,-10.69 -2.69,1.21 -5.58,2.69 -7.56,5.19 -4.61,5.79 -8.09,4.51 -11.21,2.38 -1.46,-2.99 -3.58,-5.88 -6.51,-8.73 -1.4,-6.54 -2.52,-10.86 -4.07,-17.79 -0.04,-0.05 -0.07,-0.11 -0.09,-0.16 0.42,0.06 0.82,0.19 1.24,0.22 -2.88,-15.22 6.96,-19.26 10.48,-27.36 3.16,-7.29 1.61,-15.26 -2.69,-20.75 -4.43,-5.65 -10.52,-6.71 -16.23,-2.36 -4.84,3.69 -6.1,10.33 -3.93,16.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2506.77 851.01c7.58,-4.4 13.96,-12.17 20.53,-19.02 1.09,-1.13 1.28,-4.63 1.08,-6.9 -0.83,-8.28 -4.67,-14.35 -10.95,-15.39 -6.3,-1.14 -11.6,2.91 -12.84,11.69 -0.66,4.73 -0.02,9.88 -0.58,17.18 -2.63,7.76 -0.89,14.62 2.76,12.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2653.23 2406.85c2.81,-1.69 4.13,-3.33 6.38,-7.77 0.13,0.86 0.23,1.63 0.43,2.41 8.5,-6.04 6.87,-11.96 2.08,-15.43 0,-2.15 -0.11,-4.35 -0.34,-6.93 -1.52,-19.57 -8.64,-29.08 -24.2,-29.46 -0.05,0.02 -0.1,0.03 -0.16,0.04 0.27,-0.31 0.56,-0.6 0.76,-0.94 -5.75,-2.3 -9.47,-1.13 -9.53,4.92 -0.96,0.98 -1.91,2.07 -2.95,3.4 -3.57,7.23 -6.9,12.31 -3.81,21.6 0.09,0.06 0.18,0.11 0.27,0.19 -0.48,-0.04 -0.92,-0.14 -1.39,-0.12 3.34,16.4 13,23.59 21.03,32.2 2.98,3.07 7.02,1.43 8.25,-4.2 1,0.13 2.04,0.17 3.17,0.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2656.17 3470.08c3.52,-8.46 2.9,-17.4 -2.5,-24.34 -4.22,-5.49 -9.79,-9.58 -15.98,-6.23 -6.53,3.52 -6.69,11.56 -6.26,19.27 0.1,2.42 1.16,4.71 3.1,8.76 5.23,5.86 9.64,9.05 14.73,8.11 2.56,-0.46 5.77,-2.87 6.92,-5.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2372.47 1103.89c-1.47,0.66 -3,1.48 -4.64,2.77 -11.32,4.52 -15.75,12.48 -15.61,26.9 -0.48,-0.49 -0.95,-1.01 -1.46,-1.53 -8.69,-0.71 -16.9,-4.55 -18.9,8.18 -1.12,7.38 -3.12,11.2 -9.33,10.58 -3.96,-0.38 -7.82,0.07 -10.82,4.37 -2.18,3.07 -2.04,11.22 0.47,13.65 7.06,6.76 15.14,4.86 22.9,4.26 5.8,-0.34 8.07,-6.38 9.43,-12.7 2.02,-9.59 7.81,-11.13 13.37,-13.8 1.39,0.91 3.12,1.62 5.28,2.08 24.85,6.98 28.97,3.31 29.79,-24.01 0.06,-2.27 -0.61,-4.64 -1.7,-8.93 0.87,0.29 1.7,0.63 2.61,0.92 6.18,-4.01 11,-6.58 14.42,-10.84 7.72,-9.91 5.51,-21.07 -4.54,-27.01 -7.19,-4.18 -13.48,-3.09 -19.46,3.1 -5.67,5.84 -9.63,13.35 -11.8,22.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M3058.91 1768.97c-0.45,7.45 3.55,11.29 7.96,14.6 8.57,6.36 10.59,5.6 22.62,-10.11 -2.34,-7.7 -4.71,-13.28 -7.78,-18.02 -3.44,-5.25 -8.26,-7.28 -13.43,-4.5 -6.02,3.31 -8.92,9.85 -9.37,18.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2288.67 818.19c1.02,8.65 1.91,15.43 7.62,17.42 5.7,1.99 11.86,3.61 17.34,-0.93 4.56,-3.82 6.41,-9.95 4.65,-16.56 -2.53,-9.63 -9.04,-12.86 -16.3,-13.96 -7.09,-1.06 -11.3,3.22 -13.31,14.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1797.23 1201.22c1.24,6.66 5.36,10.34 10,12.4 5.33,2.34 10.03,-0.88 12.19,-6.76 2.47,-6.57 3.39,-13.99 5.98,-23.16 2.73,-5.84 1.46,-11.39 -0.69,-10.6 -8.15,2.75 -16.31,6.42 -23.76,11.44 -4.63,3.12 -4.96,10.31 -3.73,16.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1633.95 3249.54c-7.54,0.11 -9.74,7.32 -10.6,15.17 -0.69,6.16 -0.8,12.46 3.31,19.88 7.27,6.92 12.43,5.7 16.73,-1.3 3.76,-6.09 6.39,-12.62 3.53,-20.72 -2.64,-7.19 -6.24,-13.08 -12.98,-13.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2251.72 2703.03c-3.39,1.85 -7.19,5.1 -8.91,9.03 -3.11,6.97 -2.3,14.71 2.12,21.02 5.88,8.38 12.44,12.8 21.52,2.27 2.29,-11.59 -0.68,-19.64 -4.57,-27.11 -2.34,-4.51 -6.14,-7.33 -10.16,-5.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M983.2 633.17c7.67,6.13 13.03,-0.74 18.09,-7.03 0.74,-0.84 1.33,-1.92 2.83,-5.06 2.06,-14.22 -1.22,-21.95 -11.43,-23.24 -6.98,-0.82 -11.49,3.62 -14.05,11.21 -2.59,7.81 -0.51,20.11 4.56,24.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2744.16 425.74c4.92,0.24 9.82,-1.82 16.41,-3.93 7.12,-15.14 6.5,-21.6 -0.82,-25.14 -6.89,-3.37 -13.74,-4.34 -20.13,1.3 -4.46,3.85 -6.77,9.43 -5.93,16.33 0.91,7.42 5.3,11.15 10.47,11.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1971.77 256.21c10.49,0.8 14.51,-4.51 16.44,-20.16 0.83,-6.63 0.45,-12.72 -5.05,-15.48 -8.83,-4.45 -16.96,-0 -21.27,11.82 -1.12,3.14 -0.45,7.3 0.06,13.39 2.5,7.25 5.79,10.13 9.82,10.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2197.4 3004.21c-2.32,-1.67 -5.86,-2.48 -8.33,-1.56 -4.31,1.59 -5.03,7.23 -5,12.14 0.14,13.4 5.21,23.89 13.5,25.42 7.4,1.31 13.45,-2.35 14.51,-15.92 -2.48,-11.74 -8.79,-15.79 -14.67,-20.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M860.54 1759.71c-4.11,-5.4 -1.18,-11.68 -1.47,-17.57 -0.79,-15.02 -4.89,-18.38 -17.92,-14.69 -1.81,0.48 -3.33,2.68 -6.26,6.41 -0.2,26.29 1.16,28.36 15.45,27.21 3.38,-0.3 6.79,-0.88 10.2,-1.36z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1698.47 1692.32c7.15,-7.31 7.11,-14.31 4.56,-21.75 -2.02,-5.84 -4.81,-10.61 -9.71,-13.25 -6.76,-3.67 -14.08,0.12 -16.75,9.05 -5.12,17.71 2.03,27.5 21.9,25.95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1330.83 2256.15c-3.94,-0.46 -8,-1.95 -11.89,-1.52 -2.56,0.27 -6.31,2.37 -7.11,4.94 -0.79,2.47 1.32,9.47 2.4,9.49 11.63,0.86 14.81,16.54 26.01,20.52 10.51,-25.14 8.23,-31.48 -9.41,-33.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1541.87 1871.43c0.26,8.41 3.73,15.02 9.83,17.42 7.03,2.79 10.85,-4.2 13.99,-10.9 0.98,-2.13 1.06,-4.88 1.79,-9.76 -0.47,-13.39 -5.28,-18.66 -13.82,-16.37 -7.38,2.01 -12.02,10.34 -11.8,19.61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2213.63 1605.06c2.98,-2.47 7.65,-4.06 7.9,-10.75 -5.61,-8.23 -11.9,-15.58 -22.95,-17.68 0.51,-0.76 1.05,-1.61 1.57,-2.54 3.96,-39.93 1.62,-45.13 -25.01,-59.67 -1.81,-0.96 -3.66,-1.77 -7.76,-2.1 -17.67,8.49 -22.99,23.17 -19.2,43.26 1.67,8.9 6.48,15.52 12.22,21.06 5.94,5.8 12.39,7.22 21.49,5.22 -0.18,0.43 -0.39,0.78 -0.54,1.26 4.04,7.15 6.6,12.7 9.55,17.71 7.49,12.42 11.74,13.43 22.72,4.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2447.43 888.86c-1.62,7.66 4.18,15.24 15.14,18.76 2.65,0.86 5.79,-0.48 10.48,-2.2 6.18,-5.83 7.34,-11.16 4.81,-17.77 -1.77,-4.67 -4,-8.61 -8.03,-10.24 -9.06,-3.64 -20.4,2.22 -22.39,11.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2648.18 2872.02c-2.95,-2.99 -6.98,-4.98 -10.69,-5.68 -4.14,-0.72 -7.45,2.57 -9.68,10.18 0.1,17.53 6.46,25.55 17.91,27.51 4.68,0.82 7.96,-2.35 8.49,-7.83 0.89,-8.98 -0.16,-18.05 -6.04,-24.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1779.43 764.27c7.54,2.75 15.24,4.87 21.9,-5.62 -1.82,-11.35 -5.94,-17.81 -12.9,-21.41 -7.37,-3.68 -15.14,0.52 -16.74,9.09 -1.39,7.36 1.91,15.81 7.74,17.94z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1475.57 3650.46c0.88,-5.86 -0.53,-12.28 -1.49,-20.79 -9.04,-10.01 -13.79,-10.22 -16.77,-3.25 -3,6.71 -4.6,13.88 -3.67,21.5 0.73,6.27 2.55,12.55 8.48,13.34 6.45,0.76 12.12,-2.24 13.44,-10.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1975.21 1184.6c0.17,-0.01 0.33,-0.05 0.48,-0.09 -0.07,-0.19 -0.36,0.04 -0.48,0.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1975.14 1186.22c-4.54,9.69 -5.08,17.03 -1.06,23.93 5.92,10.2 16.67,10.54 23.31,1.13 4.64,-6.6 3.27,-15.74 -2.79,-23.62 -6.04,-7.89 -12.58,-4.43 -18.91,-3.14 0.01,0.15 -0.06,0.55 -0.56,1.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1709.12 2217.8c5.49,-5.57 8.89,-13.32 8.01,-22.6 -0.78,-8.18 -4.67,-13.31 -13.19,-14.72 -9.56,2.29 -15.03,7.83 -14.15,17.85 0.68,8.5 3.82,17.02 11.2,20.13 2.45,1.04 6.32,1.18 8.13,-0.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2359.8 2406.89c-2.66,4.39 -2.09,9.48 -0.22,17.05 2.88,9.57 4.68,16.85 7.13,23.66 1.37,4.04 4.76,4.24 7.69,3.28 1.74,-0.59 4.53,-2.44 4.63,-3.97 1.17,-14.78 2.06,-29.81 -6.3,-42.28 -3.23,-4.8 -9.4,-3.65 -12.94,2.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2322.45 915.29c4.42,4.56 9.03,3.4 13.78,1 4.7,-2.46 8.4,-6.23 10.16,-14.79 -3.37,-14.03 -11.24,-15.47 -19.22,-15.5 -2.3,-0.01 -5.49,2.8 -6.76,5.5 -3.81,7.7 -2.46,19.19 2.04,23.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2843.85 1917.31c-4.08,-2.22 -6.89,3.5 -8.2,11.23 8.29,19.02 22.87,16.76 34.62,22.4 2.85,1.35 6.37,-0.09 6.97,-4.31 0.47,-3.24 -0,-8.08 -1.66,-10.28 -8.57,-11.36 -20.98,-13.17 -31.74,-19.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M866.11 1920.31c7.8,3.07 13.04,-2.73 17.57,-9.62 3.53,-5.4 3.45,-11.28 0.55,-17.13 -4.21,-8.52 -9.69,-11.95 -18.71,-4.69 -4.71,6.29 -7.87,11.2 -7.75,17.85 0.04,7.01 3.33,11.63 8.34,13.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2706.04 1053.62c-0.12,8.29 3.03,14.36 9.75,15.93 6.3,1.43 13.23,7.16 18.55,-2.47 1,-1.85 1.55,-4.7 1.43,-6.96 -0.39,-6.38 -2.62,-11.73 -9.12,-15.78 -4.77,-0.85 -7.72,-1.33 -10.51,-0.94 -4.89,0.75 -10.06,2.2 -10.11,10.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2851.91 1438.54c1.93,4.07 5.51,6.88 10.2,11.83 9.16,5.57 15.03,22.51 23.94,10.08 6.48,-8.97 -3.92,-17.75 -6.87,-26.25 -3.72,-10.87 -12.97,-13.96 -22.49,-10.68 -4.31,1.49 -7.37,9.6 -4.77,15.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1586.48 659.03c-4.04,8.38 -4.23,16.54 5.61,22.51 6.82,2.19 11.48,1.24 14.68,-4.49 4.6,-8.29 3.48,-17.76 -2.44,-22.88 -5.93,-5.06 -13.94,-3.38 -17.85,4.85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2112.6 1242.73c-3.54,8.54 1.5,13.59 5.8,18.72 3.65,4.39 7.75,7.88 13.06,6.03 5.34,-1.87 7.93,-6.75 8.16,-16.03 -2.29,-6.4 -3.83,-11.69 -6.78,-14.14 -7.31,-6.08 -16.48,-3.46 -20.24,5.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M3140.79 1907.64c4.08,-0.63 6.83,-5.02 5.55,-10.87 -1.33,-6 -2.71,-12.04 -4.99,-17.44 -4.23,-9.97 -13.95,-9.86 -18.85,0.32 -4.07,8.45 -7.43,17.41 -9.33,28.77 10.74,6.54 19.02,0.52 27.62,-0.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2051.05 4143.89c-10.72,-2.51 -13.66,4.71 -13.43,14.64 0.2,9.14 2.52,17.29 10.37,20.17 4.58,1.6 7.4,-2.24 9.3,-6.79 4.37,-10.47 0.98,-18.97 -6.24,-28.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2852.74 784.81c5.35,-0.04 9.36,-3.02 12.47,-11.93 -0.06,-6.44 -0.14,-10.43 -1.45,-13.66 -3.53,-8.67 -9.1,-13.02 -16.93,-9.84 -8,3.25 -12.48,13.55 -10.52,23.55 1.52,7.71 7.26,11.9 16.43,11.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M3419.14 1200.77c5.86,-0.36 12.07,-0.9 16.42,-6.88 1,-1.35 1.3,-5.34 0.5,-6.78 -4.86,-8.25 -11.35,-14.02 -19.56,-14.96 -5.5,-0.59 -8.94,4.48 -12.59,12.37 1.98,12.3 7.53,16.75 15.23,16.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M940.11 1511.52c1.58,-1.19 2.47,-3.78 4.23,-7.9 0.47,-3.49 0.61,-4.98 0.17,-5.93 -6.38,-11.23 -12.86,-14.8 -18.49,-10.24 -5.46,4.47 -8.42,15.73 -5.94,22.95 2.63,7.84 10.2,8.44 20.04,1.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1753.09 1085.3c1.52,6.54 5.09,10.5 12.59,11.33 4.67,-2.09 7.99,-3.13 9.61,-5.86 5.19,-8.43 5.26,-18.05 0.44,-23.55 -4.65,-5.36 -10.35,-7.35 -16.43,-4.34 -6.19,3.01 -8.64,12.11 -6.21,22.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2300.12 693.04c-3.27,5.07 -5.32,11.46 -2.6,17.37 3.41,7.55 9.75,7.36 15.72,6.24 5.39,-1 8.79,-5.18 10.67,-13.91 -2.73,-6.11 -4.89,-10.58 -8.05,-13.13 -5.68,-4.59 -11.39,-3.15 -15.73,3.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2670.62 2015.04c1.61,3.11 3.53,6.1 5.69,8.67 4.35,5.29 11.17,5.06 16.28,-0.16 4.81,-4.87 5.98,-13.25 1.65,-19.99 -3.07,-4.73 -7.45,-8.13 -13.24,-12.52 -14.77,8.52 -16.3,12.78 -10.38,23.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2438.64 3367.23c1.68,-7.19 -1.84,-11.9 -6.1,-15.5 -3.63,-3.07 -7.51,-1.91 -12.74,2.02 -2.73,4.92 -4.67,8.2 -4.93,11.69 -0.52,6.88 2.27,12.22 7.63,14.2 6.15,2.34 14.16,-3.84 16.15,-12.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M3018.57 1301.37c-4.59,-5.89 -10.04,-8.06 -15.68,-2.92 -5.4,4.94 -6.48,15.56 -2.6,23.6 1.51,3.14 3.73,5.8 5.98,8.16 4.86,5.09 11.27,4.09 15.08,-3.49 1.78,-3.73 1.25,-9.39 1.14,-16.73 -1.77,-4.62 -2.65,-6.93 -3.92,-8.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2860.84 1283.92c3.49,1.47 7.54,0.81 13.01,-0.16 7.2,-7.72 5.5,-14.4 2.14,-21.22 -2.22,-4.37 -5.06,-8 -9.4,-6.95 -6.03,1.47 -11.42,5.33 -12.54,13.55 -0.86,6.41 1.48,12.69 6.79,14.78z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2660.97 2285.86c-7.47,3.19 -10.28,8.78 -7.57,15.24 3.64,8.78 8.44,16.96 13.47,24.65 1.35,2.11 5.31,2.13 7.94,1.73 1.11,-0.23 2.9,-3.91 2.74,-5.91 -0.61,-8.73 -1.41,-17.47 -2.99,-26.01 -1.31,-7.11 -6.42,-8.96 -13.6,-9.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1085.41 2010.19c-2.77,-3.7 -6.23,-6.98 -10.44,-5.59 -5.42,1.84 -7.9,7.92 -8.81,14.08 -1.02,6.72 1.99,12.11 7.7,17.52 7.28,1.22 10.86,-2.79 13.36,-8.74 2.71,-6.18 1.99,-12.25 -1.81,-17.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1858.44 1128.6c4.22,-4.84 5.11,-10.42 1.54,-16.21 -3.34,-5.45 -8.24,-7.15 -13.12,-4.57 -4.86,2.62 -7.15,8.21 -5.94,15.19 1.26,7.21 2.51,14.43 4.25,21.48 0.47,1.73 2.82,2.8 4.24,4.2 1.05,-2.02 2.3,-3.9 3.07,-6.06 0.74,-2.21 1.05,-4.73 2.69,-9.23 1.91,-2.99 2.57,-3.92 3.27,-4.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2527.55 1068.31c-7.92,-6.49 -17,-5.01 -26.75,-4.3 -0.14,-1.06 -0.33,-2.17 -0.62,-3.34 -7.34,-5.34 -12.99,-5.31 -14.11,4.65 -0.77,7.07 3.68,10.58 9.27,10.41 1.67,-0.04 3.24,-0.54 4.81,-2.19 0.39,1.2 0.87,2.46 1.52,3.95 5.75,13.74 13.15,18.62 23.18,15.79 4.03,-1.21 7.88,-4.1 8.85,-9.14 1.34,-6.85 -1.65,-12.12 -6.16,-15.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2796.89 897.11c-7.36,11.15 -3.26,17.64 3.15,22.41 6.11,4.51 13.07,6.51 18.91,-0.23 3.97,-4.52 3.59,-11.11 0.32,-16.65 -5.32,-9.27 -12.43,-10.73 -22.38,-5.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1147.31 2645.84c1.47,6.21 4.07,11.8 9.49,12.34 5.44,0.56 8.57,-4.89 11.89,-12.52 0.45,-4.83 0.75,-7.61 -0.09,-9.54 -4.68,-10.72 -10.09,-13.88 -15.81,-9.38 -5.72,4.4 -7.39,11.08 -5.49,19.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2396.63 656.99c2.5,-1.22 5.84,-4 6.38,-6.8 1.43,-7.56 -0.89,-14.64 -4.89,-20.57 -3.7,-5.4 -8.1,-6.32 -14.29,-0.67 -5.03,8.11 -7.81,14.67 -2.96,21.96 4.17,6.15 9.55,8.94 15.76,6.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2493.69 574.39c-1.55,-4.63 -2.37,-7.55 -3.91,-8.58 -9.19,-6.17 -15.95,-3.68 -19.62,6.72 -2.91,8.4 0.13,16.99 7.64,21.82 3.92,2.55 7.84,2.43 11.42,-0.38 4.93,-3.97 4.78,-10.65 4.46,-19.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M666.1 973.81c6.11,0.02 11.7,-5.97 12.25,-13.68 0.41,-6.35 -0.49,-12.78 -5.19,-16.6 -5.12,-4.09 -9.27,0.35 -14.86,5.5 -1.6,5.76 -2.67,9.69 -2.12,13.08 1.15,6.45 3.94,11.67 9.92,11.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M3287.72 1538.13c-4.57,6.12 -4.56,10.58 -1.34,14.74 3.69,4.75 8.42,6.39 13.4,7.07 10.7,1.37 20.62,-4.59 19.09,-11.39 -2.18,-9.45 -9.42,-7.53 -14.61,-9.61 -4.57,-1.88 -9.69,-1.58 -16.53,-0.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2222.14 877.37c9.58,1.67 16.11,-0.53 14.84,-13.03 -1.06,-9.83 -7.16,-14.46 -15.46,-12.4 -2.54,0.64 -5.72,3.28 -6.86,6.06 -3.38,8.35 0.37,14.1 7.48,19.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1586.42 1707.92c2.39,1.36 5.95,1.89 8.23,0.65 5.43,-2.89 9.82,-16.91 7.72,-25.74 -1.93,-8.21 -7.38,-10.81 -15.85,-8.26 -5.78,5.08 -9.74,9.07 -9.48,16.03 0.32,8.02 3.77,14.03 9.38,17.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1261.68 1935.31c4.17,1.11 7.67,-1.67 11.86,-7.01 2.27,-7.05 1.21,-11.75 -0.68,-16.4 -2.65,-6.43 -6.71,-9.48 -12.18,-7.55 -5.45,1.9 -7.97,7.61 -8.37,14.23 -0.47,8.5 2.45,14.83 9.38,16.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2178.64 2409.36c-7.15,-2.7 -11.8,-0.77 -14.23,5.74 -2.92,8.02 -0.24,14.78 4.48,20.45 3.93,4.79 8.92,7.29 13.72,4.28 5.07,-3.16 5.91,-10.3 4.1,-16.6 -1.3,-4.59 -4.18,-8.49 -8.06,-13.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1963.19 2503.03c-1.81,-4.24 -4.21,-8.55 -7.17,-11.53 -2,-2.01 -5.75,-3.19 -8.02,-2.12 -2.16,1 -4.72,5.37 -4.55,8.11 0.28,6.04 2.08,11.89 4.56,19.83 5.62,5.65 10.05,7.63 14.59,2.58 4.67,-5.24 2.97,-11.39 0.59,-16.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1936.36 1676.8c1.68,4.76 4.19,8.92 8.15,9.48 2.39,0.32 5.57,-1.93 7.43,-4.3 3.02,-3.77 3.29,-9.51 1.1,-13.69 -4.73,-9.04 -10.13,-17.39 -15.28,-25.68 0.03,0.34 -0.25,-0.32 0.59,2.6 0.16,12.5 -5.65,21.27 -1.99,31.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1345.74 456.8c7.23,-3.66 8.15,-11.87 2.58,-24.7 -0.39,-1.04 -1.5,-1.58 -3.93,-3.39 -13.34,4.61 -15.85,8.95 -12.82,18.8 2.52,8.15 8.57,12.15 14.18,9.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1185.18 1022.3c1.95,10.56 8.45,15.94 15.03,12.78 6.8,-3.33 9.98,-12.4 6.97,-21.68 -2.71,-8.34 -7.81,-10.69 -16.19,-6.11 -4.31,5.45 -6.86,9.51 -5.81,15.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2643.27 3670.84c-8.26,-4.82 -12.64,0.85 -13.53,13.73 3.49,8.68 7.57,14.19 13.64,15.03 2.35,0.4 6.15,-1.46 7.19,-3.86 3.5,-7.98 0.04,-20.56 -7.3,-24.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2308.91 1926.94c0.42,6.16 7.55,6.58 12.21,2.9 3.95,-3.14 3.94,-8.2 2.76,-13.24 -1.6,-6.93 -5.56,-9.79 -12.91,-10.05 -6.61,-1.41 -11.19,-3.01 -18.47,-5.49 5.21,11.22 15.58,13.2 16.42,25.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2137.48 3352.8c0.47,-11.76 -0.33,-20.64 -6.71,-26.32 -2.13,-1.94 -5.76,-2.75 -8.23,-1.9 -3.92,1.36 -6.67,5.53 -6.14,11.32 0.88,10.3 3.18,20.3 10.23,26.28 5.48,4.73 9.04,0.49 10.86,-9.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2924.72 2074.17c3.76,-7.8 6.2,-14.61 7.25,-21.74 1.23,-8.26 -3.47,-14.39 -9.85,-14.18 -6.37,0.17 -11.47,6.33 -10.81,13.95 0.82,9.82 2.22,19.68 13.41,21.96z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2550.19 1892.5c-0.74,-0.48 -1.44,-0.96 -2.25,-1.43 -7.86,4.81 -9.83,10.98 -6.97,19.13 2.15,6.13 6.24,10.07 11.31,10.09 6.75,0 8.82,-6.15 9.27,-14.5 0.81,0.31 1.52,0.72 2.45,0.94 5.56,5.09 10.54,10.72 14.12,3.23 4.64,-9.81 2.15,-23.24 -3.75,-26.68 -5.35,-3 -11.01,-5.88 -17.19,-3.7 -4.32,1.51 -5.79,6.15 -6.99,12.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1798.17 1639.09c0.36,3.27 1.22,4.22 4.85,0.67 4.63,-7.67 8.83,-13.12 11.75,-19.41 1.01,-2.09 -0.57,-7.34 -2.21,-9.79 -3.6,-5.39 -8.71,-6.2 -13.3,-2.31 -2.11,1.74 -4.36,5.93 -4.2,8.82 0.4,7.42 2.2,14.66 3.11,22.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1878.69 905.2c4.87,-7.61 9.54,-15.5 14.27,-23.21 -5.46,-9.07 -10.65,-16.76 -21.88,-10.17 -7.67,11.21 -4.6,20.91 -1.85,30.52 1.47,5.29 6.77,6.97 9.46,2.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1863.75 1530.66c1.71,-10.28 -1.96,-17.8 -9.47,-19.31 -6.4,-1.27 -8.91,2.95 -10.4,17.51 -0.13,1.19 0.4,2.4 1.44,5.67 12.44,7.56 16.79,6.08 18.43,-3.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2830.39 1786.71c6.62,-1.6 9.93,-10.34 6.73,-16.8 -1.94,-4 -4.71,-8.07 -7.88,-10.41 -9.44,-6.95 -17.27,-0.95 -17.71,13.39 -0.11,3.29 2.14,6.66 5.33,11.36 5.89,1.79 9.92,3.37 13.53,2.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2104.59 1096.29c-4.27,0.75 -5.85,6.11 -7.45,10.48 -3.85,10.92 -2.88,17.32 3.42,22.57 7.16,5.94 12.7,3.13 16.93,-8.71 -1.33,-7.36 -2.56,-12.08 -4.29,-16.44 -1.72,-4.36 -4.36,-8.63 -8.62,-7.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1302.16 3808.8c-6.77,3.29 -7.55,11.53 -3.2,22.8 4.59,11.94 9.53,11.49 16.93,-1.7 0.5,-0.97 0.43,-2.43 0.7,-6 -1.69,-12.39 -5.4,-19.59 -14.43,-15.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1384.56 2117.69c-1.49,-7.41 -1.07,-12.52 -1.82,-17.29 -1.13,-7.41 -5.54,-9.86 -10.99,-8.84 -4.08,0.7 -7.55,3.3 -8.51,8.77 -1.5,8.58 2.43,13.79 7.49,18.59 4.82,4.55 9.74,-5.2 14.13,-0.75 -0.07,-0.18 -0.17,-0.27 -0.3,-0.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1386 2119.63c-0.38,-0.61 -0.74,-1.07 -1.15,-1.46 1.03,1.73 0.95,1.34 1.15,1.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M3210.72 1939.49c5.22,1.34 9.55,-1.17 12.14,-7.27 2.13,-5.2 0.14,-9.75 -2.2,-13.62 -3.98,-6.45 -9.81,-7.2 -17.41,-5.64 -2.6,18.54 -0.62,24.43 7.47,26.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M3025.28 738.41c-12.83,10.55 -6.28,19.36 -0.72,28.28 17.19,-14.4 17.21,-15.14 0.72,-28.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2167.07 1641.18c-4.3,7.42 -2.82,14.39 3.02,19.67 1.56,1.49 3.54,2.27 7.37,3.53 4.6,-1.41 8.17,-2.26 9.67,-5.07 4.26,-7.84 1.17,-14.5 -3.84,-19.68 -4.9,-5.12 -12.64,-4.57 -16.22,1.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2171.18 1505.73c-0.54,0.95 -1.08,1.82 -1.61,2.87 0.02,3.23 0.02,3.23 -0.07,3.5 1,-2.1 1.56,-4.24 1.69,-6.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2178.66 1472.8c-1.94,-1.98 -5.59,-3.17 -7.93,-2.26 -5.39,1.95 -7.81,8.11 -6.67,14.7 0.84,4.71 3.57,8.91 5.6,13.14 1.21,2.48 1.65,4.96 1.52,7.36 3.75,-6.73 7.75,-11.15 10.6,-16.45 3.38,-5.99 1.04,-12.36 -3.12,-16.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M3132.05 1346.85c1.65,5.12 5.08,7.91 9.39,7.48 4.43,-0.48 7.79,-4.46 7.84,-9.74 0.12,-10.11 -0.89,-20.27 -4.9,-29.74 -15.05,14.11 -16.57,18.98 -12.32,32.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2464.58 2455.66c6.24,-0.87 7.15,-6.88 5.83,-15.99 -3.27,-5.92 -5.47,-10.44 -8.62,-12.78 -1.86,-1.39 -5.97,-0.36 -7.98,1.51 -4.48,4.11 -4.86,10.64 -3.1,16.8 2.31,7.88 7.44,11.42 13.86,10.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M885.2 982.13c1.6,6.07 8.97,9.42 14.87,6.06 2.35,-1.3 3.69,-5.39 5.89,-10.6 -0.1,-4.7 -0.22,-7.45 -1.22,-9.38 -4.11,-7.98 -9.41,-7.99 -14.74,-2.29 -3.89,4.07 -6.59,9.37 -4.8,16.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M566.86 1107.16c4.14,5.02 9.21,3.12 13.3,-0.5 2.2,-1.96 3.5,-5.58 5.28,-10.61 -0.55,-7.72 -3.6,-10.52 -7.5,-11.92 -5.13,-1.73 -9.66,-0.55 -12.23,6.01 -2.29,5.89 -2.74,12.3 1.14,17.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2930.39 2760.57c-3.64,7.61 -3.59,13.42 1.38,17.34 3.5,2.82 7.71,2.38 10.61,-1.48 3.51,-4.87 4.21,-11.3 1.28,-16.88 -3.44,-6.57 -7.96,-5.17 -13.27,1.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1410.25 1309.82c7.55,5.11 13.06,1.88 16.6,-7.5 0.43,-1.12 0.28,-2.46 0.07,-5.94 -10.33,-11.35 -14.29,-11.48 -18.98,-2.69 -3.01,5.58 -2.14,13.08 2.31,16.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1750.45 1531.28c-16.11,0.94 -17.31,1.31 -15.02,14.73 1.45,9.01 -3.33,24.77 5.73,26.08 12.66,1.8 3.51,-15.24 7.35,-22.69 2.56,-4.9 2.87,-11.75 1.94,-18.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1139.57 2207.12c-0.24,4.71 -0.35,7.31 0.35,9.5 2.03,6.43 5.7,10.18 11.42,7.85 4.08,-1.68 6.09,-6.27 6.63,-11.31 0.7,-6.59 -0.87,-12.65 -5.98,-15.52 -5.75,-3.16 -8.94,1.99 -12.42,9.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M847.79 2416.9c1.95,1.87 5.87,2.51 8.14,1.34 4.69,-2.43 8.78,-7.07 8.51,-14.14 -0.29,-7.76 -2.26,-14.97 -11.94,-14.17 -3.59,3.94 -5.76,6.75 -7.1,10.08 -2.53,6.2 -1.87,12.59 2.4,16.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1680.67 2133.76c7.14,6.25 14.34,13.04 23.21,14.09 4.55,0.48 6.69,-4.33 6.8,-9.76 0.11,-5.75 -3.18,-8.55 -9.03,-11.23 -6.56,-3.02 -10.92,-5.67 -15.46,-7.91 -3.35,-1.51 -5.42,1.33 -6.86,4.73 -1.52,3.7 -0.97,8.06 1.34,10.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2807.99 829.99c8.91,-1.18 18.25,0.21 17.06,-12.72 -0.94,-9.52 -9.18,-7.44 -14.85,-8.19 -3.9,-0.42 -7.89,-0.48 -11.83,-0.06 -4.81,0.48 -6.6,9.32 -3.24,14.92 2.68,4.42 6.49,5.41 12.86,6.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M3469.01 942.62c1.62,-4.07 2.86,-6.7 2.42,-8.67 -2.5,-11.87 -7.67,-16.63 -13.57,-13.13 -6.16,3.63 -8.71,13.28 -4.79,21.96 3.83,8.52 9.39,6.25 15.94,-0.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2790.21 1182.49c-3.38,-1.69 -5.28,-2.54 -7.17,-2.4 -5.22,0.35 -9.35,2.85 -10.46,10.13 -0.82,5.33 0.93,9.64 4.32,12.48 4.36,3.71 9.28,4.26 13.44,0.31 5.68,-5.42 5.24,-12.3 -0.13,-20.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2661.38 1152.03c5.33,-1.85 7.42,-11.31 4.93,-19.15 -1.68,-5.07 -4.89,-8.51 -8.97,-8.28 -5.51,0.25 -8.77,4.92 -9.4,14.33 2.41,10.26 6.34,15.62 13.44,13.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M3369.7 860.19c6.71,0.4 13.07,-5.33 12.42,-12.13 -0.9,-9.72 -7.03,-10.58 -13.18,-10.69 -0.99,-0.04 -1.92,0.38 -4.25,2.11 -2.64,16.04 -1.22,20.35 5.01,20.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2117.96 255.47c5.43,-2.46 7.21,-11.04 4.72,-19.49 -2.34,-7.82 -6.58,-8.19 -17.28,0.56 -1.03,4.57 -1.87,7.37 -1.16,9.44 2.26,8.1 6.75,12.63 13.71,9.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1596.79 501.29c4.5,0.82 7.77,1.51 10.19,-0.09 6.11,-3.79 8.24,-10.79 6.63,-19.1 -0.42,-2.1 -2.06,-4.87 -3.64,-5.49 -7.02,-2.8 -11.31,2.8 -14.8,9.2 -2.43,4.51 -2.36,9.54 1.62,15.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1549.74 3323.04c-1.63,-2.1 -5.39,-3.31 -7.78,-2.64 -6.24,1.84 -9.24,12 -5.72,21.36 3.16,8.6 8.42,9.15 14.83,0.35 2.99,-8.34 2.16,-14.5 -1.33,-19.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2881.27 1717.79c4.22,-0.37 6.95,-4.11 7.75,-9.52 0.8,-5.38 -1,-9.83 -4.17,-13.17 -7.03,-7.31 -15.13,-3.53 -17.59,8.35 -1,4.76 -1.26,9.74 0.24,13.91 6.01,-0.17 9.88,0.9 13.78,0.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1856.31 2753.52c-9.23,5.71 -11.21,11.09 -8.14,26.42 9.18,-0.07 14.55,-5.13 17.06,-13.87 0.83,-2.91 0.1,-7.43 -1.23,-10.25 -1.5,-3.36 -4.86,-4.1 -7.69,-2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M3145.31 1784.02c3.93,2.01 7.73,0.06 10.03,-4.79 2.34,-4.89 1.6,-9.89 -0.69,-14.1 -3.67,-6.67 -8.92,-9.79 -15.37,-7.95 -5.35,1.52 -8.66,5.5 -7.62,15.28 5.19,5.45 9.15,9.17 13.64,11.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2204.96 1776.33c6.42,-1.64 10.67,-8.88 10.09,-19.7 -0.59,-10.55 -6.8,-10.03 -14.51,-6.82 -5.32,7.85 -6.45,14.77 -2.84,21.87 1.56,3.1 3.88,5.57 7.26,4.65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2838.66 1492.55c-2.9,1.4 -3.76,1.93 -4.54,2.7 -3.16,3.33 -5.79,7.56 -4.57,12.8 1.05,4.55 2.98,9.28 5.61,12.51 4.02,4.94 11.5,2.51 15.4,-4.05 4.2,-7.12 3.2,-12.93 -4.42,-22.35 -1.26,-1.47 -3.6,-1.58 -7.48,-1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1467.05 1879.4c-2.51,2.01 -4.58,4.61 -4.24,8.92 0.59,8.12 7.26,14.66 14.9,13.1 7.64,-1.6 8.78,-8.29 4.39,-18.33 -5.77,-5.49 -10.2,-7.59 -15.05,-3.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2626.86 479.61c5.87,-4.29 10.69,-6.51 14.14,-10.61 3.18,-3.81 1.57,-9.05 -1.22,-13.14 -3.55,-5.12 -8.53,-9 -12.7,-4.64 -6.75,7.03 -11.08,17.13 -9.51,28.79 0.41,3.14 4.83,2.33 9.28,-0.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1701.42 2031.36c4.34,-7.89 5.38,-16.04 0.41,-23.73 -1.55,-2.38 -4.89,-3.76 -7.49,-3.98 -3.16,-0.25 -5.25,3.06 -5.67,7.01 -0.42,3.65 -0.14,7.4 0.22,13.37 6.1,11.75 9.46,13.01 12.52,7.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1800.49 1450.67c3.42,-2.57 5.45,-2.33 7.29,-2.81 6.56,-1.69 10.87,-6.16 8.83,-15.37 -1.57,-6.85 -6.11,-9.37 -11.52,-7.65 -6.03,1.82 -6.76,8.06 -6.07,14.51 0.49,4.72 3.13,9.19 1.47,11.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2026.22 3827.02c3.61,-6.68 4.63,-14 0.04,-20.63 -4.01,-5.78 -8.46,-4.97 -13.79,1.46 -2.74,10.5 0.49,16.4 5.83,20.81 2.61,2.2 6,1.93 7.92,-1.65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2590.82 1799.25c3.64,-5.24 2.51,-11.47 -0.55,-16.92 -4.33,-7.79 -10.84,-9.93 -19.86,-8.93 -4.92,13.27 2.16,19.33 7.51,25.96 3.91,4.67 9.15,5.4 12.91,-0.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1525.83 3166.56c-5.5,0.71 -8.72,5.62 -8.87,12.56 -0.1,6.68 3.37,11.42 8.71,16.54 11.04,-1.25 11.16,-10.35 10.47,-19.08 -0.55,-7.13 -4.77,-10.82 -10.31,-10.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1618.79 920.28c3.37,-6.41 5.65,-10.72 4.29,-16.12 -1.69,-7.05 -5.66,-10.16 -11.21,-9.32 -6.42,0.95 -11.32,8.61 -9.84,15.71 2.05,9.75 6.41,15.72 16.76,9.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1192.22 787.33c5.88,6.59 10.7,1.16 15,-4.44 2.06,-2.61 4.58,-4.66 6.68,-7.22 3.09,-4.05 1.47,-9.81 -3.51,-10.82 -4.8,-0.98 -9.74,-0.53 -16.4,0.76 -5.37,8.28 -6.96,15.86 -1.77,21.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2883.27 1381.92c5.13,-2.12 6.61,-10.92 2.6,-14.28 -3.1,-2.61 -6.74,-4.81 -10.38,-5.65 -8.78,-1.92 -11,4.42 -4.98,19.16 5.32,1.06 9.31,2.03 12.75,0.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M3028.9 1640.73c2.77,-4.17 3.2,-8.97 0.69,-16.04 -3.95,-2.86 -6.78,-4.43 -9.57,-4.46 -4.44,-0.15 -7.58,3.25 -8.37,8.69 -0.97,7.03 2.02,12.34 6.65,15.38 3.89,2.55 7.75,0.48 10.6,-3.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2996.44 1473.6c4.99,-4.3 4.58,-8.75 -3.77,-21.95 -13.51,4.46 -16.54,10.21 -11.75,18.13 4.12,6.88 10.26,8.35 15.52,3.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M3315.93 476.9c5.68,5.18 14.71,3.74 17.91,-4.07 3.75,-9.09 -1.62,-13.22 -9.33,-15.62 -5.54,1.93 -8.87,4.54 -10.27,9.55 -0.96,3.61 -1.12,7.61 1.69,10.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1224.68 1539.35c-1.26,-15.95 -3.44,-18.86 -9.76,-17.21 -5.28,1.47 -8.68,5.55 -9.01,12.24 -0.34,6.98 6.21,10.64 15.37,9.13 0.85,-0.12 1.55,-1.4 3.4,-4.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1928.32 1421.98c3.52,-7.15 1.91,-15.55 -3.67,-18.82 -5.93,-3.48 -9.15,-0.72 -13.25,14.14 10.06,10.87 13.71,11.36 16.92,4.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2481.58 2099.88c-4.81,-5.07 -8.31,-7.56 -12.51,-6.32 -2.91,0.91 -5.87,2.01 -6.57,6.49 -1.26,8.49 1.95,14.77 7.04,19.27 3.38,3.02 7.45,3.43 11,-0.23 4.55,-4.76 4.48,-10.67 1.04,-19.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1246.97 2516.56c3.72,3.35 8.4,1.43 10.46,-2.66 4.63,-9.02 10,-18.12 5.94,-30.31 -5.87,3.4 -10.21,6.57 -13.9,10.48 -2.15,2.32 -4,5.69 -4.93,8.97 -1.4,4.86 -1.12,10.35 2.42,13.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1174.49 875.09c4.08,5.55 9.01,4.72 13.21,0.62 5.56,-5.38 6.16,-12.31 0.14,-20.86 -7.36,-3.03 -11.21,0.39 -13.74,6.28 -2.03,4.58 -2.66,9.75 0.39,13.95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2395.03 1886.09c-0.44,2.32 -0.92,4.66 1,6.97 18.01,4.63 21.74,-10.28 26.25,-23.52 -0.11,0.2 0.2,0.02 -2.22,-0.69 -21.17,-4.22 -21.17,-4.22 -25.03,17.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2253.3 1985.91c2.8,-1.13 5.89,-2.04 7.98,-4.34 3.4,-3.85 3.55,-8.89 0.24,-13.14 -2.98,-3.86 -6.91,-4.09 -12.66,-2.19 -6.26,3.98 -10.56,8.05 -8.2,15.33 2.38,7.34 7.76,6.37 12.63,4.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1094.6 3087.21c3.41,-3.1 5.33,-8.13 3.02,-13.17 -1.39,-2.91 -4.32,-6.47 -6.67,-6.63 -6.3,-0.49 -7.77,5.99 -8.45,14.73 2.99,10.63 7.66,9.05 12.09,5.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M792.16 1649.6c-2.55,-0.41 -5.83,0.64 -7.92,2.56 -4.44,4.11 -4.43,10.32 -1.86,18.83 4.02,3.27 6.74,5.27 9.46,5.28 5.25,-0.22 9.12,-3.68 9.74,-10.99 0.67,-8.03 -3.04,-14.69 -9.41,-15.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2462.03 289.12c4.99,-2.23 7.75,-7.06 8.43,-16.21 -3.68,-8.19 -8.01,-10.3 -13.17,-9.13 -6.48,1.54 -9.62,7.88 -8.48,16.37 1.09,8.07 6.69,11.91 13.21,8.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1441.54 22.01c4.29,4.72 9.4,3.6 13.38,-0.89 1.92,-2.22 2.54,-6.31 3.29,-12.01 -2.79,-4.66 -4.89,-7.89 -7.46,-8.64 -5.39,-1.73 -9.67,1.49 -11.9,7.91 -1.78,5.11 -0.33,10.36 2.69,13.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2695.52 469.9c4.61,-2.9 7.34,-9.02 5.37,-15.54 -2.87,-9.25 -8.74,-7.82 -14.57,-4.52 -0.87,0.5 -1.69,1.26 -3.68,3.83 -1.21,4.38 -1.86,7.12 -1.16,9.06 2.66,8.18 7.82,11.02 14.03,7.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1752.92 1531.93c2.2,-0.28 3.57,-1.23 4.45,-2.62 -0.96,0.01 -1.93,-0.04 -3.02,0.1 -1.71,2.27 -1.47,2.37 -1.43,2.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1767.47 1531.67c4.37,1.23 8.01,-0.87 9.34,-6.44 1.45,-5.6 -1.33,-9.78 -4.74,-12.64 -3.76,-3.24 -7.33,-2.18 -10.67,1.95 -2.99,3.7 -1.46,10.88 -4.03,14.77 3.93,0.17 6.98,1.48 10.1,2.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2772.23 1629.83c-3.47,-4.99 -10.1,-4.49 -12.49,0.99 -3.27,7.36 -3.2,14.19 4.19,17.75 0.87,0.42 1.86,0.28 4.55,-0.2 8.77,-5.36 8.26,-11.96 3.75,-18.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1643.86 2813.1c-6.95,1.64 -9.84,7.64 -6.65,16.61 0.35,1.09 1.12,2.01 3.27,4.29 9.02,3.59 13.06,0.04 12.74,-9.79 -0.35,-7.18 -3.42,-12.49 -9.36,-11.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1660.28 529.67c1.44,1.45 3.53,1.78 7.14,2.06 3.2,-2.15 5.01,-3.4 5.96,-5.46 3.03,-6.36 1.48,-11.95 -3,-15.84 -4.61,-4.1 -9.34,-3.01 -12.41,3.04 -2.93,5.85 -2.08,11.81 2.31,16.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2194.4 629.69c-6.11,-5.49 -11.6,-4.16 -14.52,4.44 -2.16,6.29 -0.59,13.16 4.9,15.87 6.18,3.02 8.88,-3.15 11.19,-8.91 0.46,-1.13 0.41,-2.53 0.39,-6.03 -0.82,-3.3 -1.22,-4.67 -1.96,-5.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2684.54 2498.62c4.69,-5.77 2.18,-11.41 -0.89,-16.66 -0.6,-0.93 -1.69,-1.44 -4.21,-2.44 -9.54,1.47 -11.63,7.41 -7.97,15.99 2.53,5.95 9.57,7.31 13.06,3.11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2551.77 2948.34c-4.92,-4.15 -11.74,0.61 -13.26,9.32 -0.97,5.57 1.56,9.51 6.98,12.67 4.07,-1.52 7.21,-2.91 8.74,-5.67 3.15,-5.99 2.57,-12.13 -2.47,-16.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2561.93 783.19c0.39,7.61 4.9,10.14 9.98,10.89 5.07,0.74 9.7,-1.26 13.14,-6.18 3.16,-4.58 2.42,-9.47 -1.13,-12.64 -2.22,-2.03 -5.43,-2.3 -10.4,-3.29 -7.16,1.18 -11.89,3.15 -11.58,11.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2321.74 2850.93c-8.4,-3.2 -14.4,-11.61 -24.41,-7.66 6.06,8.87 10.24,15.79 15.08,21.87 3.77,4.81 9.01,7.02 13.02,0.92 2.86,-4.35 0.48,-9.55 -3.68,-15.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2385.75 2494.76c0.66,12.08 6.29,15.54 19.88,10.39 1.3,-10.95 -2.09,-16.65 -7.7,-20.79 -3.06,-2.16 -6.2,-1.48 -8.3,1.1 -1.97,2.37 -4.03,6.26 -3.88,9.31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M749.76 604.79c2.31,-0.89 5.14,-4.61 5.55,-7.54 0.9,-6.3 -0.96,-12.58 -5.82,-15.37 -5.25,-3.03 -9.23,-0.12 -11.29,9.24 1.32,10.31 4.21,16.39 11.56,13.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2646.92 1030.32c2.19,-1.64 4.58,-5.1 5.01,-8.08 0.87,-6.76 -2.44,-11.36 -8.88,-14.93 -9.68,1.82 -14.52,6.87 -10.87,17.62 2.37,7.02 9.11,9.34 14.74,5.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1094.12 2936.51c5.61,-0.13 9.68,-8.7 7.71,-16.63 -1.29,-5.12 -4.93,-7.12 -10.96,-6.8 -5.76,3.04 -7.25,7.15 -6.57,12.56 0.91,6.91 4.26,11.01 9.81,10.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2971.77 1188.53c-4.99,-1.38 -7.94,-2.25 -10.83,-2.09 -5.15,0.4 -10.17,2.17 -9.94,10.46 0.24,7.91 5.35,9.7 10.43,10.68 5.08,0.94 9.94,-0.35 13.6,-5.26 3.31,-4.47 2.12,-9 -3.25,-13.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2267.11 1164.5c-0.67,8.63 2.56,13.71 11.93,12 6.54,-3.42 11,-7.28 8.1,-14.45 -3.06,-7.71 -9.27,-8.16 -14.97,-5.32 -2.2,1.1 -4.86,4.94 -5.06,7.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2433.25 1133.24c-3.88,-4.92 -8.68,-5.47 -13.02,-0.35 -4.6,5.42 -3.7,14.02 2.36,18.35 2.23,1.64 5.63,0.72 10.13,-0.31 5.67,-7.19 4.2,-13.02 0.52,-17.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1435.78 1972.32c-5.4,3.03 -7.06,12.61 -3.39,18.83 4.21,7.19 9.38,7.54 15.67,-0.34 0.52,-5.84 0.8,-9.78 -0.3,-12.9 -2.32,-6.72 -6.99,-8.44 -11.97,-5.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1772.49 1720.58c0.72,9.73 5.63,15.18 11.4,13.29 7.52,-2.49 7.8,-9.67 5.2,-17.52 -0.35,-1.1 -1.12,-1.97 -3.3,-4.34 -7.76,-2.29 -14.25,-2.79 -13.29,8.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2530.89 1737.53c-3.48,1.93 -7.84,3.64 -6.29,10.08 1.3,5.32 5.46,6.72 9.26,6.24 3.73,-0.48 8.1,-1.17 10.81,-3.94 6.15,-6.11 4.7,-12.11 -3.86,-16.14 -4.5,1.38 -7.31,2.38 -9.92,3.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1232.73 1707.37c7.36,1.34 9.99,-5.07 10.54,-13.25 0.06,-1.07 -0.44,-2.29 -1.67,-5.48 -12.16,-3.99 -15.06,-2.56 -16.05,5.36 -0.84,7.3 1.69,12.43 7.17,13.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1738.08 2132.17c-3.36,2.86 -4.89,16.46 -2.51,19.87 0.82,1.16 3.28,1.29 4.61,0.66 4.75,-2.15 8.19,-6.1 8.37,-15.02 -3.3,-5.93 -6.64,-8.69 -10.48,-5.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2254.03 1114.77c0.05,7.66 7.15,13.04 12.82,9.69 6.71,-3.98 7,-10.59 0.51,-18.64 -8.07,-2.73 -13.4,-0.81 -13.32,8.95z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1971.7 1507.1c1.73,-7.22 0.82,-11.93 -2.1,-15.53 -3.65,-4.44 -7.92,-6.86 -12.85,-2.89 -4.79,3.82 -5.28,12.45 -1.02,19.16 4.51,7.06 9.63,6.89 15.97,-0.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1568.29 1951.63c-2.5,-1.76 -3.44,-2.26 -4.39,-2.15 -6.98,0.55 -11.14,4.86 -9.69,14.13 1.19,7.69 8.2,13.35 13.21,10.74 6.85,-3.61 7.32,-10.49 4.2,-18.27 -0.48,-1.07 -1.12,-2.05 -3.34,-4.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2917.84 3219.38c-1.37,-0.81 -4.02,0.16 -5.37,1.54 -1.44,1.33 -2.92,4.24 -2.7,6.15 1.29,10.72 7.39,18.07 13.12,24.55 3.29,3.75 6.93,-1.51 7.91,-9.56 -2.71,-11.1 -6.18,-18.8 -12.96,-22.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1530.78 1381.92c1.08,-2.84 0.89,-7.63 -0.3,-10.57 -2.82,-7.04 -7.88,-6.48 -14.49,-2.65 -3.93,15.48 -2.59,21.19 3.09,22.34 5.83,1.17 9.58,-3.24 11.7,-9.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2370.56 1544.34c4.5,2.26 7.41,3.89 10.22,3.45 2.47,-0.44 5.39,-2.38 6.94,-4.88 2.03,-3.36 0.47,-7.53 -1.7,-9.98 -2.82,-3.16 -6.02,-6.12 -9.5,-7.84 -3.8,-1.82 -7.98,-0.33 -10.11,4.37 -2.29,4.95 -0.01,9.43 4.15,14.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2386.97 3158.99c-8.97,5.14 -4.98,13.78 -2.82,21.74 0.31,1.12 0.82,2.23 2.62,4.86 10.79,-6.68 12.86,-13.85 7.52,-23.26 -1.24,-2.34 -5.57,-4.33 -7.32,-3.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2877.06 605.72c-3.83,2.98 -4.12,8.37 -1.08,12.54 5.42,7.58 10.38,5.61 16.67,-8.36 -4.77,-9.92 -10.48,-8.24 -15.59,-4.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2577.75 2568.32c-4.46,-5.11 -8.91,-3.51 -13.99,2.93 -1.91,7.43 -0.52,11.82 2.96,15.07 4.52,4.12 9.27,4.51 12.93,-1.37 3.59,-5.85 2.14,-11.87 -1.91,-16.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2416.72 1485.15c-1.31,-7.58 -6.07,-10 -11.24,-8.53 -7.79,2.21 -8.71,8.69 -3.31,18.41 11.52,1.36 15.82,-2.17 14.55,-9.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1860.81 1324.41c-1.19,3.47 0.99,7.29 3.91,8.62 5.47,2.48 11.15,5.51 17.72,-1.52 -0.9,-13.9 -8,-14.2 -15.04,-13.13 -2.38,0.36 -5.6,3.29 -6.59,6.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M3110.06 958.23c6.18,-5.38 11.07,-10.64 3.54,-17.12 -4.28,-3.75 -9.89,-2.61 -12.31,3.58 -3.3,8.51 -0.33,13.64 8.77,13.54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2921.46 3171.52c-2.34,-4.41 -7.07,-6.06 -10.13,-2.57 -5.68,6.37 -4.44,12.66 3.75,17.71 10.18,-1.1 10.27,-7.53 6.38,-15.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M3053.37 919.49c1.28,-2.64 1.69,-7.19 0.82,-10.06 -1.36,-4.75 -4.98,-6.93 -10.79,-6.89 -5.08,3.5 -7.39,7.66 -6.72,12.73 0.46,3.17 2.24,7.11 4.31,8.55 4.78,3.27 9.56,1.38 12.38,-4.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2244.23 934.11c2.14,-1.22 4.11,-5.82 4.41,-9.1 0.48,-5.48 -2.48,-9.39 -6.67,-10.81 -1.76,-0.61 -3.85,0.38 -7.3,1.92 -3.56,4.34 -4.44,8.22 -2.9,11.64 2.71,6.04 7.23,9.29 12.46,6.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1142.44 745.59c5.15,4.32 8.83,1.46 11.43,-6.91 -0.8,-4.33 -1.14,-7.06 -2.37,-8.67 -3.85,-5.05 -8.75,-5.83 -12.12,-0.04 -3.35,5.72 -1.49,11.85 3.07,15.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1971.69 511.87c2.63,-3.62 3.81,-5.71 4.37,-8.12 1.29,-5.63 -1.11,-9.48 -4.55,-12.55 -2.77,-2.49 -5.76,-1.99 -8.25,0.26 -4.68,4.22 -5.56,10.55 -3.36,16.68 1.78,4.88 5.68,6.55 11.79,3.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1867.35 2479.75c-8.03,-3.35 -9.9,4.16 -10.22,14.76 4.39,10.83 9.3,12.56 13.9,4.07 3.93,-7.37 2.2,-16.45 -3.68,-18.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2584.08 3863.74c-7.6,8.21 -5.11,16.99 7.5,20.27 4.28,-6.93 5.61,-12.6 2.31,-18.4 -2.69,-4.68 -6.41,-5.54 -9.81,-1.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1716.4 1125.66c4.95,-3.33 6.11,-9.81 5.15,-16.46 -1.08,-7.97 -5.5,-9.72 -12.9,-6.89 -4.34,7.49 -5.51,13.46 -2.56,19.62 2.54,5.21 6.56,6.24 10.3,3.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1464.03 1071.9c7.15,1.83 10.99,-2.4 9.37,-14.18 -6.79,-6.94 -12.06,-6.9 -14.52,2.76 -1.23,5.12 0.94,10.28 5.15,11.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2735.64 852.7c4.22,-0.1 7.84,-2.43 9.61,-7.34 1.8,-5.11 0.14,-9.75 -4.29,-14.94 -4.37,-0.77 -7.49,-1.01 -9.91,0.56 -3.91,2.56 -5.37,7.51 -3.97,12.88 1.31,4.99 3.89,8.95 8.55,8.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2529.7 3805.81c-6.06,7.19 -2.48,13.11 4.78,18.49 9.33,-1.74 11.7,-7.62 7.71,-15.73 -2.81,-5.66 -8.18,-7.85 -12.5,-2.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1055.42 3716.49c-2.21,-1.76 -5.36,-1.5 -9.85,-1.01 -2.63,4.53 -4.31,7.97 -4.16,11.27 0.16,5.48 3.6,9.04 7.46,9.85 4.03,0.82 7.72,-1.89 9.16,-6.99 1.31,-4.72 1.22,-10.19 -2.61,-13.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M638.54 710.98c1.75,0 3.56,-1.49 6.16,-3.94 0.09,-5 0.07,-9.04 -1.51,-11.43 -2.66,-4.07 -6.93,-4.8 -10.14,-1.5 -1.86,1.89 -3.07,6.28 -2.79,9.3 0.37,5.65 4.25,7.51 8.28,7.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1057.14 3676.91c2.24,-9.94 2.62,-17.86 -5.59,-18.23 -5.94,-0.26 -6.96,7.03 -7.55,13.16 -0.07,1.17 0.14,2.43 0.25,3.63 0.45,6.85 4.06,7.94 12.89,1.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1542.86 2106.86c8.3,-7.01 9.18,-12.03 3.56,-28.24 -14.22,2.58 -10.64,15.04 -10.18,25.16 0.19,3.98 3.89,5.33 6.62,3.07z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1691.25 2605.74c-5.68,2.51 -6.43,12.94 -1.23,18.46 5.31,5.59 8.76,1.28 11.1,-7.3 -0.48,-9.79 -4.15,-13.64 -9.87,-11.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2261.97 1406.36c0.12,1.05 0.31,2.17 0.57,3.39 6.65,6.54 12.1,7.69 17.31,1.23 2.82,-3.53 5.24,-7.62 8.28,-10.74 2.87,-2.86 5.77,-0.72 7.63,2.3 1.05,1.71 1.45,4.67 1.21,6.91 -1.07,11.19 -11.09,14.31 -14.26,26 9.84,12 15.42,27.36 14.23,46.38 -0.31,4.94 4.39,8.53 8.88,6.73 3.73,-1.48 7.1,-4.33 11,-10.98 1.9,-16.4 5.88,-28.91 2.14,-40.54 -4.57,-14.19 8.4,-23.77 3.64,-38.16 0.62,-0.6 1.32,-1.23 2.08,-2.08 4.57,-7.77 8.06,-13.63 11.65,-19.36 6.41,-10.31 4.88,-20.3 -0.5,-30.26 -2.67,-4.8 -5.88,-8.58 -10.84,-8.06 -0.22,-1.43 -0.39,-2.79 -0.71,-4.37 -0.85,-4.11 -1.95,-5.9 -5.15,-8.69 -0.16,-0.26 -0.36,-0.43 -0.52,-0.7 0.5,-0.04 1.03,-0.08 1.59,-0.22 -6.07,-6.35 -9.22,-14.95 -15.71,-13.85 -0.86,-1.13 -1.65,-2.39 -2.39,-3.85 -3.22,-1.65 -5.39,-2.01 -8.87,-1.54 0.11,-1.01 0.13,-2.06 0.01,-3.39 -9.79,-14.04 -24.8,-11.89 -33.24,-25.17 -0.96,-1.57 -6.63,-0.84 -8.17,1.14 -3.98,5.26 -5.84,14.28 -10.41,17.32 -7.39,5.03 -10.44,-9.84 -17.7,-9.74 -3.92,0.11 -8.97,-1.98 -11.63,0.39 -8.39,7.58 -14.38,3.36 -20.96,-3.54 -1.83,-1.86 -5.67,-1.73 -7.38,2.96 -1.39,3.9 -0.38,6.97 0.99,10.46 3.95,10.27 15.67,3.35 19.4,14.95 3.31,10.22 10.74,14.42 18.96,16.29 4,0.93 5.76,4.95 9.23,8.6 -0.56,1.31 -1.09,2.57 -1.58,4.05 -0.45,7.58 -0.21,12.75 0.82,20.24 0.13,0.26 0.28,0.5 0.41,0.76 -0.64,-0.22 -1.27,-0.47 -1.91,-0.65 0.27,10.17 1.7,17.88 8.41,20.67 0.21,0.75 0.41,1.53 0.7,2.33 0.47,-0.25 -0.5,0.19 0.8,1.97 0.25,0.66 0.52,1.26 0.76,1.89 -0.71,-0.23 -1.39,-0.53 -2.07,-0.76 6.82,24.34 6.82,24.34 23.15,19.82 0.06,-0.08 0.1,-0.15 0.14,-0.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1689.14 1597.14c-2.06,-6.43 -7.52,-5.63 -16.31,4.42 1.36,11.2 5.25,15.49 12.18,11.22 5.02,-3.2 6.14,-9.35 4.12,-15.65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M3118.37 864.38c7.08,4.04 13.28,3.76 16.53,-9.57 -4.07,-10.18 -9.59,-11.81 -15.6,-9.38 -2.42,0.95 -5.19,4.21 -5.93,7.18 -1.25,5.13 1.15,9.56 5.01,11.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1551.77 2845.41c1.88,-7.78 2.33,-15.32 -7.72,-16.97 -6.36,5.28 -6.12,11.35 -3.76,17.62 1.35,3.67 4.37,5.29 7.41,4.18 1.6,-0.61 3.55,-2.82 4.07,-4.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2034.04 1537.44c4.32,0.09 8.03,-3.01 8.92,-8.24 0.9,-5.4 -1.95,-9.69 -6.03,-11.45 -4.11,-1.74 -7.93,-0.22 -10.31,4.59 -2.07,4.17 -3.64,8.82 -5.66,13.34 0.13,-0.06 0.66,-0.34 2.21,-0.51 5.1,0.72 7.98,2.23 10.87,2.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2020.97 1535.68c-0.02,0 0,0 0,0 -0.04,0.05 -0.06,0.04 0,0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1789.92 894.73c-5.75,4.63 -5.45,9.3 2.92,19.23 7.72,-1.62 13.89,-3.46 11.2,-13.75 -2.2,-8.15 -8.48,-10.12 -14.12,-5.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1437.33 1786.73c-6.71,5.03 -3.37,12.78 -0.65,19.45 0.44,0.97 1.4,1.63 3.82,3.13 8.85,-1.32 11.61,-6.97 8.46,-15.39 -2.18,-5.78 -6.74,-10.9 -11.64,-7.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1396.75 2371.47c7.14,-0.05 9.7,-6.26 9.14,-14.86 -0.1,-1.31 -0.45,-2.44 -2.18,-5.52 -11.99,-2.35 -15.76,0.22 -15.49,8.19 0.27,6.78 2.9,12.26 8.53,12.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1896.24 397.93c3.29,-3.22 5.71,-6.04 6.23,-9.35 0.99,-5.63 -1.61,-9.54 -5.96,-10.8 -4.9,-1.36 -8.92,4.64 -7.48,12.28 0.57,3.05 3.62,5.39 7.21,7.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2335.81 817.44c4.66,5.07 12.26,2.11 14.4,-5.87 2.73,-10.18 -2.58,-13.23 -11.25,-13.45 -7.69,6.3 -8.98,12.94 -3.15,19.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2242.8 3149.51c0.03,1.21 0.52,2.39 2,5.76 7.7,6.76 12.96,5.48 14.39,-4.33 1.2,-8.16 -4.12,-16.08 -9.82,-15.41 -6.5,0.8 -6.99,7.36 -6.57,13.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1330.79 2099.05c3.65,6.18 8.23,4.61 13.57,-1.81 1.59,-8.75 0.3,-14.36 -4.13,-18.29 -2.67,-2.37 -5.67,-2.22 -7.82,0.44 -4.75,5.83 -5.58,12.92 -1.63,19.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2182.86 2226.86c-0.76,-3.27 -2.8,-6.43 -4.97,-8.6 -2.49,-2.42 -5.93,-2.41 -8.05,0.62 -1.78,2.55 -3.34,6.15 -3.61,9.53 -0.57,7.08 3.1,11.48 9.73,14.73 6.69,-4.03 8.38,-9.7 6.89,-16.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M826.92 3693.92c-2.17,7.63 0.78,14.4 6.25,17.93 1.53,1 6.25,-1.47 6.83,-3.53 1.19,-4.24 0.51,-9.27 -0.45,-15.97 -5.95,-6.01 -10.61,-5.32 -12.63,1.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1785.7 1780.07c-5.5,-13.56 -10.6,-15.46 -13.91,-7.58 -2.59,6.05 -3.02,12.66 1.87,16.63 5.47,4.44 9.05,-0.74 12.04,-9.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1855.16 1790.29c-10.94,4.44 -12.94,8.88 -9.62,16.77 1.98,4.72 5.24,8.16 9.5,5.9 2.4,-1.23 4.81,-4.74 5.59,-7.88 1.26,-5.07 -0.95,-9.67 -5.47,-14.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1810.64 1788.27c-4.7,6 -4.11,15.95 0.97,19.35 6.03,4 8.66,-2.26 11,-7.84 0.46,-1.01 0.56,-2.31 0.42,-5.87 -3.64,-8.21 -7.82,-11.47 -12.39,-5.64z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2916.48 1210.15c-6.22,-0.34 -9.11,3.88 -5.4,14 2.09,2.7 2.8,3.59 3.66,4.21 5.12,3.7 9.91,3.55 12.29,-4.02 2.1,-6.78 -2.84,-13.71 -10.55,-14.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1544.72 2969.19c0.61,6.12 2.56,12.26 8.82,11.35 5.69,-0.86 7.8,-6.25 7.65,-13 -0.11,-5.41 -2.95,-8.59 -8.69,-10.11 -5.58,2.77 -8.3,6.64 -7.78,11.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M828.04 836.79c8.73,-0.28 12.8,-4.24 10.13,-13.87 -1.39,-4.95 -4.11,-9.36 -8.66,-7.71 -7.42,2.64 -7.44,9.83 -5.04,17.61 0.31,1.08 1.18,1.97 3.58,3.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2020.67 990.91c6.25,0.72 8.85,-4.97 8.48,-12.13 -0.13,-3.46 -2.27,-6.77 -5.24,-11.57 -8.08,-1.67 -10.48,3.25 -10.99,10.29 -0.52,7.32 1.79,12.82 7.75,13.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2832.9 2216.42c-7.51,0.42 -11.01,4.13 -8.86,11.53 2.33,7.78 9.59,10.87 13.82,6.08 6.46,-7.29 1.59,-12.46 -4.96,-17.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1787.18 2242.36c-3.18,6.91 -0.75,12.75 3.23,16.75 4.94,5.05 9.11,2.66 11.54,-7.23 -6.34,-13.65 -11.73,-16.2 -14.77,-9.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2639.44 1779.25c0.63,16.52 4.16,21.98 10.89,19.36 2.17,-0.93 5.26,-5.43 5.02,-7.93 -0.85,-10.48 -6.19,-14.72 -15.91,-11.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1822.72 2327.54c-2.77,-9.27 -8.07,-9.48 -14.77,-1.39 -1.07,9.6 -2.63,18.89 6.53,17.85 6.45,-0.75 10.39,-9.18 8.23,-16.46z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2216.39 344.02c6.58,5.59 10.59,0.47 13.77,-8.92 -2.47,-6.81 -6.18,-8.68 -10.07,-8.22 -2.52,0.28 -5.68,2.23 -6.97,4.75 -2.57,5 0.04,9.63 3.27,12.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M3237.79 634.45c2.38,-0.8 5.4,-4 6.01,-6.89 1.21,-5.69 -1.95,-9.58 -6.17,-10.5 -6.97,-1.54 -11.67,1.28 -9.43,13.61 3.97,2.57 7.04,4.48 9.6,3.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1894.34 1502.03c-2.77,6.04 -0.53,11.77 3.59,15.91 3.25,3.21 7.12,4.33 10.61,0.92 5.39,-5.27 2.27,-10.59 -2.16,-17.32 -5.4,-3.36 -9.76,-4.31 -12.03,0.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2967.9 961.75c5.97,-0.53 8.51,-4.85 5.93,-14.48 -5.67,-6.45 -10.31,-6.39 -14.08,-1.12 -1.6,2.22 -2.5,7.17 -1.73,9.79 1.54,5.09 5.86,6.21 9.87,5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1851.82 778.69c-1.97,3.59 -2.9,6.24 -2.53,8.36 1.31,6.81 4.79,10.87 10.61,9.48 4.16,-1.01 7.28,-4.68 7.15,-10.2 -0.21,-8.65 -5.88,-8.43 -10.69,-9.15 -0.96,-0.12 -1.94,0.22 -4.55,1.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M3060.55 1147.86c-9.14,1.86 -11.99,7.79 -7.1,15.37 3.23,4.85 9.54,4.73 13.01,-0.68 4.11,-6.35 0.89,-11.15 -5.91,-14.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M958.97 4012.68c-1.33,9.94 -2.21,18.83 6.91,17.29 6.4,-1.16 8.79,-9.58 5.64,-17.76 -2.89,-7.38 -7.28,-7.03 -12.55,0.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2937.46 1121.45c3.03,7.8 12.66,10.05 17.29,4.3 1.46,-1.82 1.57,-7.04 0.69,-9.84 -1.46,-4.75 -5.16,-6.97 -11.21,-6.58 -5.4,3.17 -8.76,7.02 -6.77,12.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2975.48 1604.53c0.81,5.4 5.28,7.75 9.27,6.68 7.36,-1.96 9.85,-7.25 3.12,-16.93 -8.48,-2.21 -13.94,-0.37 -12.39,10.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2302.37 2259.41c3.42,-3.44 3.5,-8.57 1.51,-13.05 -3.58,-7.98 -8.34,-8.68 -14.35,-0.49 0.61,5.53 1.32,9.05 3.05,11.81 2.56,4.34 6.3,5.24 9.79,1.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1427.4 1571.88c3.53,6.48 7.16,8.27 11,5.89 3.92,-2.43 5.61,-7.55 3.76,-12.43 -2.34,-6.3 -7.41,-8.01 -12.39,-6.98 -5.46,1.26 -4.19,6.63 -2.36,13.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1982.55 2275.42c-1.45,-7.75 -6.71,-7.56 -11.76,-4.94 -1.81,0.89 -3.9,1.48 -5.35,2.97 -1.3,1.33 -1.91,3.72 -2.8,5.73 2.32,1.69 4.67,3.38 8.87,5.63 7.19,0.45 12.56,-1.04 11.04,-9.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M3086.89 1532.26c2.57,-6 3.02,-12.46 -1.93,-16.17 -5.02,-3.83 -9.08,0.53 -12.6,8.05 7.74,13.7 11.5,15.09 14.54,8.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2792.53 2297.83c0.63,-4.73 0.27,-10.41 -4.59,-11.57 -8.12,-2.04 -9.18,5.57 -9.91,13.1 -0.09,1.19 0.28,2.45 1.43,5.51 8.36,5.98 12.03,1.54 13.06,-7.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1658.7 2008.75c0.21,-8.96 -1.7,-14.28 -7.92,-12.79 -5.29,1.23 -7.58,8 -4.68,13.82 3.27,6.74 7.55,5.67 12.6,-1.03z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2643.74 579.44c3.39,3.38 7.46,2.51 10.07,-1.52 2.5,-3.84 3.02,-8.84 -0.03,-13.05 -1.21,-1.7 -2.96,-2.69 -6.58,-3.61 -3.33,2.17 -4.98,3.61 -5.82,5.54 -2.14,4.94 -0.75,9.55 2.36,12.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1581.58 838.44c-1.53,1.25 -2.51,3.55 -3.27,7.74 1.84,3.98 3.06,6.21 4.74,7.02 4.21,1.99 7.54,-0.37 9.23,-5.38 0.56,-1.7 -0.13,-4.68 -0.98,-6.61 -2.33,-5.14 -5.91,-5.9 -9.72,-2.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2908.97 1271.43c-2.92,2.04 -4.2,5.45 -3.48,9.41 0.9,5.6 3.97,8.58 8.47,7.92 1.86,-0.25 3.58,-1.91 6.22,-5.23 0.32,-4.68 0.11,-7.35 -0.89,-9.31 -2.63,-4.81 -6.35,-5.46 -10.32,-2.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1873.02 214.46c0.09,-2.7 -2.51,-7.36 -4.44,-7.93 -7.48,-2.1 -10.2,3.25 -8.27,14.16 7.89,5.74 12.37,3.42 12.71,-6.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2473.31 2260.8c-0.67,-1.84 -2.79,-3.83 -4.42,-3.94 -4.55,-0.61 -7.23,2.99 -7.77,8.34 -0.42,3.57 0.3,7.3 2.03,11.2 3.25,-0.92 5.08,-1.91 6.65,-3.28 3.42,-2.99 5.39,-7.19 3.51,-12.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1455.77 1712.95c-4.76,9.68 -3.71,15.96 3.98,17.5 4.14,0.83 8.08,-2.6 8.55,-7.62 0.75,-9.5 -3.87,-12.73 -12.53,-9.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2623.42 2145.4c-2.32,-4.12 -5.67,-8.15 -9.92,-5.83 -2.06,1.17 -4.05,5.72 -4.1,8.81 -0.14,7.76 4.88,10.02 11.81,11.68 9.26,-4.63 4.79,-9.98 2.21,-14.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2675.96 340.53c2.37,0.42 5.8,-2.17 7.51,-4.63 2.99,-4.44 1.68,-9.48 -2.64,-14.97 -6.51,-0.72 -9.5,2.68 -10.27,8.04 -0.79,5.21 0.78,10.76 5.41,11.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2595.08 361.85c6.7,-3.94 8.96,-8.79 4.68,-14.8 -3.73,-5.18 -9.35,-4.43 -12,1.64 -3.15,7.16 0.2,11.07 7.32,13.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2526.3 1105.99c-5.32,-2.42 -10.61,2.38 -10.25,9.27 0.43,8.31 4.99,10 12.29,7.52 4.29,-8.1 4.08,-14.01 -2.04,-16.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1589.86 2110.07c-0.9,5.33 1.99,10.4 6.21,11.01 7.71,1.1 10.35,-4.82 8.04,-16.35 -8.29,-7.17 -12.72,-3.62 -14.25,5.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1897.55 1122.92c7.73,-3.25 8.09,-9.55 1.79,-18.22 -9.19,0.26 -12.81,4.62 -9.25,14.12 1.31,3.67 4.41,5.39 7.45,4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M779.34 1896.93c-0.39,5.71 3,9.55 7.43,9.25 6.38,-0.39 7.8,-6.23 5.96,-15.47 -8.14,-6.29 -12.78,-3.8 -13.39,6.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1893.65 2057.9c5.03,-9.74 3.55,-15.52 -3.83,-17.13 -4.22,-0.91 -7.74,2.88 -8.2,7.78 -0.87,9.31 3.32,12.9 12.03,9.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1869.11 2369.46c-2.65,-2.74 -5.37,-1.76 -7.65,0.92 -3.25,3.78 -3.79,8.34 -1.18,12.97 1.07,1.82 2.97,2.87 6.45,4.01 3.24,-1.92 4.98,-3.3 5.74,-5.4 1.91,-5.25 -0.17,-9.26 -3.36,-12.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M806.77 2589.38c-8.4,0.5 -12.3,4.37 -8.54,13.58 1.36,3.34 4.03,5.25 7.06,3.84 7.19,-3.35 7.59,-9.22 1.48,-17.41z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1448.23 2320.72c-5.41,1.11 -7.89,8.51 -5,14.7 3.38,7.26 8,5.95 13.29,-0.98 0.25,-9.39 -1.7,-14.99 -8.28,-13.72z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1588.5 1244.21c0.61,3.08 2.97,6.89 5.17,7.71 2.17,0.85 6.01,-0.56 7.55,-2.81 1.59,-2.34 1.39,-6.78 0.43,-11.69 -3.34,-2.12 -5.27,-3.46 -6.96,-3.07 -4.27,0.72 -7.36,4.05 -6.19,9.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1616.49 1241.19c4.33,-0.82 6.68,-5.05 5.72,-10.45 -0.57,-3.24 -2.27,-7.01 -4.37,-8.66 -3.61,-2.8 -7.63,-1.48 -9.83,3.4 -1.91,4.18 -3.18,8.87 -4.74,13.25 0,0 -0.09,0.06 2.25,0.66 5.21,1 8.17,2.28 10.97,1.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M259.58 2479.42c7.45,-0.06 9.99,-4.33 7.84,-11.73 -1.1,-3.74 -3.69,-6.19 -7,-4.07 -5.46,3.5 -6.54,8.45 -0.85,15.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1467.71 2905.72c-4.53,0.7 -6.67,4.67 -6.73,10.18 0.01,3.94 1.53,7.31 4.68,8.48 4.28,1.58 7.67,-0.43 9.43,-5.62 0.69,-2.05 0.32,-4.73 -0.74,-9.25 -3,-2.73 -4.89,-4.02 -6.63,-3.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2819.21 2097.02c-0.8,-2.95 -3.04,-6.3 -5.28,-7.44 -3.95,-1.96 -7.63,0.4 -9.3,5.4 -1.49,4.44 -2.09,9.35 -0.96,14.23 5,0.07 8.17,0.83 10.64,-0.63 3.62,-1.97 6.41,-6.11 4.9,-11.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1961.26 408.35c2.71,-4.05 2.17,-9.81 -1.16,-12.87 -6.02,-5.51 -10.39,-2.17 -12.82,8.49 4.27,9.98 9.15,11.39 13.98,4.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1856.18 2181.24c-1.53,5.21 0.17,10.48 4.51,11.78 7.67,2.38 10.69,-2.77 8.66,-14.37 -6.32,-5.14 -11.01,-5.06 -13.17,2.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2693.06 1011.21c-1.25,2.49 -1.35,7.21 -0.39,10.03 1.73,5.16 6.07,6.4 9.83,4.7 2.33,-0.98 3.87,-4.91 5.36,-10.15 -1.8,-4.24 -3.06,-6.27 -4.62,-7.45 -3.94,-2.75 -7.89,-1.45 -10.17,2.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2983.18 3316.69c-3.98,1.45 -6.02,6.75 -4.25,11.44 2.78,7.35 7.27,5.65 12.37,-0.59 0.89,-9.82 -2.65,-13 -8.11,-10.85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M3190.49 1897.54c0.8,-5.51 -2.16,-10.35 -6.48,-10.8 -6.68,-0.75 -8.66,4.24 -5.59,13.97 6.65,6.46 10.87,5.04 12.07,-3.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1955.7 4098.72c-1.49,-0.05 -4.05,2.04 -4.41,3.78 -1.99,9.44 1.65,13.86 10.42,12.7 3.72,-10.24 2.03,-16.18 -6.01,-16.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2554.57 2084.89c-1.73,-2.15 -4.85,-2.55 -8.7,-2.28 -1.42,4.84 -2.23,8.79 -1.25,11.54 1.85,5.16 5.73,6.35 9.41,3.03 3.8,-3.36 3.54,-8.54 0.53,-12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M3028.91 2162.47c-7.87,-5.25 -12.19,-2.77 -13.49,6.29 -0.55,3.97 1.34,7.22 4.45,7.62 6.73,0.95 10.78,-2.54 9.04,-13.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2413.91 3500.44c-1.76,8.67 1.94,16 7.93,15.86 7.1,-0.17 5.85,-7.41 3.98,-15.84 -5.32,-6.27 -10.1,-9.01 -11.91,-0.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2077.96 1623.6c1.99,4.87 6.47,6.5 10.15,2.64 3.93,-3.98 2.35,-8.69 -2.37,-13.55 -8.08,-0.67 -10.83,3.53 -7.78,10.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2384.48 1893.52c-3.02,0.57 -5.07,3.12 -5.08,7 -0.01,3.91 1.85,6.92 4.93,7.65 3.14,0.73 5.24,-1.6 6.32,-5.3 0.99,-3.28 1.87,-6.64 2.96,-10.01 -0.12,0.09 -0.6,0.35 -1.75,0.62 -3.6,0.29 -5.51,-0.21 -7.37,0.05z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2393.61 1892.76c0,0.03 0,0.08 0,0.08 0.04,-0.05 0.06,-0.08 0,-0.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2698.56 2271.8c-1.34,6.93 1.83,11.73 7.38,11.99 6.72,0.32 7.47,-5.14 4.7,-13.9 -5.89,-5.44 -10.49,-6.3 -12.08,1.91z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2708.53 2073.54c6.34,-4.5 7.19,-9.81 3.6,-15.53 -2.59,-4.11 -6.12,-6.02 -9.86,-2.33 -2.48,2.46 -2.89,6.37 -1.25,9.67 1.46,2.99 3.69,5.34 7.5,8.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2442.93 2169.27c7.08,-3.31 6.02,-10.66 -0.04,-18.49 -7.16,-0.99 -11.62,0.92 -10.24,9.16 1.08,6.67 5.46,11.65 10.28,9.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2046.98 209.54c4.29,1.63 8.05,-1.22 8.19,-7.03 0.13,-6.45 -3.7,-7.88 -9.56,-5.76 -3.99,6.38 -3.29,10.96 1.38,12.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M3081.33 1250.85c3.64,6.97 6.93,12.26 11.95,6.74 3.1,-3.46 3.34,-8.88 0.1,-12.53 -5.05,-5.72 -9.92,-6.34 -12.04,5.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1958.69 4395.78c-6.56,-1.08 -7.81,4.97 -5.96,14.03 6.09,5.54 10.7,5.59 11.97,-2.78 0.75,-5.14 -2.13,-10.57 -6.02,-11.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2770.11 1727.41c-7.38,-1.28 -11.15,1.78 -9.51,9.53 1.45,6.79 5.93,9.99 10.96,6.69 6.11,-4.09 3.12,-9.92 -1.44,-16.22z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1126.53 1814.77c6.14,3.88 8.38,-2.25 10.04,-10.94 -2.76,-9.08 -6.64,-12.27 -11.53,-7.32 -4.98,4.9 -4.19,14.72 1.49,18.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M3010.66 2353.12c-4.79,2.81 -4.11,8.04 -1.76,12.76 1.04,1.99 3.04,3.2 6.46,4.74 5.82,-3.2 7.17,-7.72 5.24,-12.92 -1.93,-5.16 -5.88,-6.95 -9.94,-4.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M3004.1 967.76c-6.2,-0.76 -9.53,1.83 -8.45,8.18 0.96,5.76 5.03,8.14 9,5.17 4,-2.94 4.55,-7.93 -0.54,-13.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2432.39 3207.33c-6.3,-5.6 -11.08,-5.53 -12.17,3.05 -0.61,5.07 2.38,10.57 6.45,11.23 7.26,1.3 7.45,-5.56 5.72,-14.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1687.45 815.92c7.67,0.46 9.51,-3.95 7.71,-10.8 -0.95,-3.82 -3.85,-5.54 -6.71,-4.35 -4.21,1.7 -4.85,6.27 -3.88,11.25 0.17,1.14 0.87,2.08 2.88,3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1832.9 1848.81c0.73,-1.56 0.45,-5.38 -0.5,-6.55 -4.46,-5.17 -8.51,-4.81 -10.91,5 4.12,8.45 8.07,8.53 11.4,1.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2063.74 625.28c6.25,0.87 7.9,-4.76 5.92,-13.77 -6.08,-5.25 -10.7,-5.07 -11.92,2.91 -0.78,5.01 2.1,10.3 6,10.85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1557.27 916.93c-3.97,-3.96 -6.75,-3.24 -9.22,-0.8 -2.51,2.35 -4.38,5.93 -2.89,9.61 2.21,5.26 6.35,6.57 9.91,2.76 1.87,-2.01 2.22,-6.38 2.21,-11.56z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M794.34 1967.4c4,3.35 6.86,0.82 8.02,-6.56 -2.61,-6.49 -5.88,-9.04 -9.35,-5.13 -3.52,3.87 -2.07,8.89 1.32,11.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2402.72 2090.84c-3.07,-3.66 -7.86,-3.92 -10.15,0.46 -3.52,6.73 0.43,10.96 6.93,13.93 7.39,-3.98 7.42,-9.4 3.21,-14.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1645.8 1654.84c1.68,-4.48 2.43,-6.9 2.37,-9.39 -0.02,-5.88 -2.21,-9.63 -7.11,-9.53 -5.11,0.07 -7.9,6.57 -6.04,14.13 1.44,5.68 4.96,7.4 10.78,4.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2651.3 3508.48c-5.48,-4.16 -9.04,-0.91 -10.39,8.79 3.33,7.88 6.84,12.8 12.08,6.96 4.03,-4.64 3.2,-12.04 -1.69,-15.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1211.48 1594.31c-0.83,8.09 3.06,10.6 10.48,7.5 4.82,-7.82 4.07,-13.36 -2.07,-15.19 -4.07,-1.18 -7.93,2.56 -8.41,7.69z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M679.51 2640.14c-0.62,9.5 1.93,13.77 7.94,10.92 3.8,-1.88 6.19,-6.87 4.38,-11.6 -2.74,-7.23 -7.28,-5.92 -12.32,0.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1999.57 1309.47c3.9,0.51 8.08,-1.01 8.87,-6.42 0.74,-5.03 -1.8,-9.55 -5.93,-10.33 -2.47,-0.48 -5.16,1.44 -8.52,4.62 -0.69,7.61 1.2,11.6 5.58,12.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M3381.89 656.89c1.95,-2.75 2.32,-6.89 -0.34,-9.4 -5.93,-5.63 -10.35,-2.72 -13.38,7.47 4.78,10.75 9.5,7.99 13.73,1.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M3109.5 1905.72c-7.79,0.81 -10.59,6 -11.28,12.59 -0.27,3.07 0.96,8.06 2.8,9.6 2.54,2.07 5.97,-0.42 7.01,-4.12 1.31,-4.71 1.69,-9.8 2.69,-15.55 0.16,-0.81 0.7,-2.38 -1.21,-2.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M742 2710.92c-5.6,3.69 -4.69,9.8 0.43,16.55 7.9,0.83 10.76,-3.13 8.76,-10.73 -1.34,-4.98 -5.3,-8.45 -9.19,-5.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M3249.28 1535.43c3.71,-3.49 4.1,-8.88 0.7,-12.85 -1.9,-2.17 -5.24,-2.27 -9.53,-2.09 -1.43,4.85 -2.22,8.96 -1.03,11.67 1.99,4.95 5.98,6.99 9.86,3.28z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2294.71 2127.53c4.18,-8.39 2.3,-13.68 -3.16,-15.74 -4.31,-1.66 -7.78,1.88 -7.89,7.51 -0.17,7.71 3.71,10.63 11.05,8.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1463.86 1121.34c-3.09,4.15 -3.05,8.7 2.04,13.75 4.19,-0.8 7.27,-1.76 8.9,-4.25 1.97,-2.9 1.65,-7.27 -0.71,-10.09 -3.35,-4.06 -7.14,-3.46 -10.23,0.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1030.63 1056.34c6.37,0.99 8.98,-2.28 7.78,-8.45 -1.03,-5.3 -4.39,-8.92 -8.64,-5.43 -3.98,3.3 -3.38,8.42 0.86,13.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2748.95 1444.27c6.06,4.69 11.07,6.28 12.58,-2.43 0.98,-5.56 -2.73,-9.59 -6.62,-10.38 -6.45,-1.37 -8.77,3.08 -5.96,12.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2580.11 591.27c3.26,3.96 7.07,3.64 11.26,-2.51 -0.06,-4.63 -0.35,-7.38 -1.55,-9.23 -2.66,-4.45 -6.35,-6.85 -9.87,-1.83 -2.99,4.12 -3.22,9.51 0.16,13.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2705.96 396.1c6.03,-4.16 10,-8.34 5.58,-15.04 -3.4,-5.09 -9.28,-4.13 -12.14,1.95 -3.12,6.67 -1.26,11.48 6.56,13.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1394.34 4262.52c-3.69,9.5 -3.06,15.91 5.24,14.93 1.94,-0.2 4.98,-4.27 5.2,-6.84 0.47,-7.58 -3.59,-9.96 -10.44,-8.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2131.56 3735.86c-4.34,1.48 -5.77,7.15 -3.69,12.04 2.65,6.37 6.96,8.57 12.52,0.71 -0.18,-9.24 -2.59,-14.87 -8.83,-12.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M915.44 1100.62c4.17,-2.67 5.14,-7.71 2.35,-12.07 -1.44,-2.3 -4.96,-2.47 -8.88,-2.28 -1.29,4.68 -1.9,8.55 -0.82,11.49 1.26,3.46 4.64,4.56 7.35,2.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1292.93 3090.43c-5.01,-3.95 -8.72,-0.82 -10.06,8.64 2.92,8.03 6.42,12.3 11.12,6.34 3.84,-4.73 3.72,-11.23 -1.06,-14.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M514.41 1521.13c4.07,-2.43 5.02,-7.75 2.49,-12.5 -2.69,-5.07 -7.05,-4.53 -10.1,-0.89 -1.85,2.22 -2.11,6.5 -1.91,11.6 3.99,1.89 7.22,3.11 9.52,1.79z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2294.73 479.82c5.11,-3.51 5.72,-9.31 0.24,-16.24 -7.61,-0.07 -11,4.06 -9.61,11.4 1.13,5.45 5.67,7.38 9.38,4.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2730.68 1403.73c-3.41,4.31 -2.21,9 1.22,12.39 2.59,2.48 5.51,1.9 8.53,-2.9 -0.27,-4.08 -0.89,-6.54 -2.13,-8.32 -2.12,-3.01 -5.31,-4.1 -7.62,-1.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1848.15 2588.24c-3.01,4.11 -3.56,9.44 0.35,12.98 3.65,3.34 7.51,1.5 10.33,-2.93 0.59,-0.94 0.88,-2.29 1.2,-5.92 -3.47,-9.78 -7.71,-9.74 -11.89,-4.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2102.59 2285.84c2.29,-3.03 1.21,-7.1 -1.06,-9.45 -4.65,-4.72 -8.53,-3.84 -10.41,5.86 3.41,8.65 7.43,9.05 11.47,3.59z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1674.09 2506.05c-2.65,-7.01 -7.02,-8.01 -12.39,-0.59 0.12,4.68 0.17,7.96 1.53,9.2 2.09,2.14 5.54,4.81 7.45,3.92 4.24,-1.93 5.27,-7.62 3.41,-12.53z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2135.07 2291.27c4.62,-3.2 3.9,-8.2 1.58,-12.83 -1.06,-1.99 -2.97,-3.28 -6.37,-4.74 -4.69,2.1 -6.38,5.43 -5.85,9.38 1.07,7.56 5.96,11.3 10.63,8.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M737.75 1536.21c4.11,-3.03 4.07,-7.58 1.57,-12.03 -1.03,-1.78 -2.85,-2.86 -6.15,-4.16 -3.05,3 -5.55,6.12 -5.33,8.69 0.81,7.34 5.64,10.64 9.9,7.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M752.61 1988.39c-0.25,-2.01 -1.51,-4.55 -2.85,-5.49 -4.21,-2.97 -7.19,0.39 -9.36,4.51 -0.94,1.82 -0.79,4.51 -0.04,8.62 2.87,2.22 4.83,3.36 6.44,2.83 4.04,-1.35 6.5,-4.93 5.82,-10.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2747.13 477.47c-3.21,-3.7 -6.68,-4.35 -10.73,2.08 0.72,5.29 1.6,9.02 3.53,11.29 2.28,2.56 5.67,2.31 7.86,-0.62 3.24,-4.28 2.56,-8.95 -0.65,-12.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2572.26 3089.51c-2.88,4.88 -0.83,9.37 2.8,12.17 2.6,2 5.55,1.68 8.47,-3.23 -0.09,-4.27 -0.31,-7.05 -1.6,-8.67 -2.95,-3.88 -6.81,-5.24 -9.67,-0.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1868.39 3344.14c0.72,5.21 1.65,8.86 3.63,11.22 2.27,2.69 5.77,2.65 7.49,-0.8 1.34,-2.69 2.39,-7.39 1.43,-9.79 -2.71,-6.55 -7.13,-7.11 -12.55,-0.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1736.69 2474.58c-2.31,4.28 -2.57,9.4 0.75,12.83 1.91,1.97 5.04,1.91 9.26,1.41 1.68,-4.81 2.7,-8.91 1.52,-11.44 -3.02,-6.36 -8.97,-7.5 -11.53,-2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2628.65 1927.91c-4.53,-5.01 -8.53,-6.5 -10.62,-1.23 -2.65,6.65 2.53,15.37 8.51,14.21 4.52,-0.91 4.89,-6.15 2.11,-12.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M831.84 497.26c6.22,0.69 9.99,-1.91 8.96,-7.73 -0.91,-5.32 -5.33,-7.78 -9.29,-5.4 -4.19,2.54 -4.48,7.41 0.33,13.13z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1889.29 2782.31c-0.31,7.67 1.81,12.62 5.98,11.61 4.09,-1.06 5.33,-7.16 3.77,-11.91 -1.85,-5.5 -5.53,-5.57 -9.76,0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2791.15 2156.93c-4.14,-3 -6.56,0.95 -7.6,8.25 2.76,7.12 6.19,8.38 9.09,3.96 2.66,-3.95 2.02,-9.67 -1.48,-12.21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M3313.03 604.03c-3.01,-4.26 -7.45,-5.24 -9.9,-0.26 -2.71,5.46 0.56,8.91 4.9,10.16 0.95,0.22 2,-0.17 4.42,-1.63 1.22,-3.74 1.62,-6.81 0.58,-8.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2369.6 735.46c0.32,-4.11 -1.67,-7.67 -5.21,-7.24 -4.83,0.68 -6.31,5.06 -4.18,12.56 5.98,3.29 8.88,0.7 9.39,-5.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1731.13 1916.69c-0.31,-4.13 -2.25,-7.21 -5.67,-6.58 -1.49,0.28 -3.27,2.68 -4.06,4.64 -1.43,3.65 -0.43,7.19 3.64,10.39 4.7,-1.33 6.28,-4.38 6.08,-8.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1544.26 1238.03c-2.02,5.73 -0.11,9.11 6.29,8.66 4.34,-6.46 2.8,-10.23 -1.78,-11.72 -1.27,-0.38 -3.96,1.41 -4.51,3.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1931.15 1949.18c2.33,-9.14 -0.17,-13.07 -6.24,-12.01 -2.96,0.53 -5.15,3.98 -4.27,7.69 1.26,5.2 4.93,6.74 10.51,4.32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2523.42 2048.4c-2.85,3.97 -2.19,9.75 1.47,12.29 4.03,2.76 6.93,-0.89 8.17,-8.32 -2.97,-7.06 -6.61,-8.26 -9.65,-3.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1285.54 3469.5c-3.96,-2.71 -6.84,0.95 -8.07,8.32 2.84,7.18 6.51,7.79 9.37,3.8 2.86,-3.89 2.26,-9.67 -1.3,-12.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1391.98 1192.7c0.95,0.86 3.58,-0.06 4.6,-1.26 2.29,-2.8 1.76,-6.35 0.22,-9.46 -0.44,-0.92 -1.43,-1.38 -3.62,-1.46 -4.32,4.63 -5.14,8.79 -1.21,12.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2944.05 366.54c2.59,2.37 6.15,2.14 7.95,-1.34 2.84,-5.65 0.19,-8.97 -5.85,-10.68 -5.98,4.05 -6.16,8.25 -2.1,12.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2680.14 952.83c1.68,-0.25 3.21,-2.18 5.15,-5.8 -0.95,-4.08 -1.95,-6.5 -3.52,-7.34 -4.07,-2.18 -7.84,-0.96 -8.6,5.08 -0.81,6.18 2.58,8.61 6.97,8.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2528.85 722.91c3.27,3.47 8.23,3.29 10.31,-1.47 2.26,-5.24 -0.95,-9.04 -7.09,-10.69 -5.96,3.64 -6.83,8.33 -3.22,12.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1910.45 681.8c4.67,4.83 8.43,4.89 10.76,0.22 1.64,-3.12 0.46,-7.32 -2.16,-9.06 -5.46,-3.6 -8.76,-0.79 -8.6,8.84z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M3095.27 868.88c-1.68,-3.82 -4.9,-4.56 -7.52,-1.37 -3.43,4.2 -2.76,8.75 2.2,13.25 5.93,-2.42 7.66,-6.61 5.32,-11.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1005.92 2260.8c4.33,-6.41 2.83,-10.2 -1.81,-11.62 -1.39,-0.41 -4.05,1.32 -4.65,2.97 -2.04,5.93 0.24,8.98 6.45,8.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1426.39 2684.25c-2.27,-2.71 -5.81,-2.6 -7.82,0.56 -2.91,4.56 -1.76,9.14 3.46,13.44 7.21,-3.22 9.31,-8.03 4.36,-14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2500.84 779.51c4.06,-2.37 4.08,-6.99 -0.38,-12.21 -5.89,-0.72 -9.28,1.62 -8.35,7.32 0.86,5.16 5.14,7.02 8.72,4.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2389.55 1053.52c6.2,0.74 9.39,-1.64 7.96,-8.06 -0.91,-4.02 -4.23,-5.72 -7.28,-4.29 -4.77,2.07 -5.47,6.26 -0.68,12.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1882.03 957.19c-0.23,3.99 1.6,7.67 5,7.17 4.63,-0.75 5.77,-5.29 3.81,-12.4 -5.93,-3.43 -8.4,-0.48 -8.81,5.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M3067.57 1850.04c-1.64,-0.93 -3.73,-0.67 -7.21,0.54 -2.42,7.27 -0.42,11.21 3.77,12.48 2.83,0.96 5.74,-0.8 6.99,-4.47 1.49,-4.39 -0.84,-6.98 -3.55,-8.55z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1391.35 3047.83c-4.03,0.97 -5.59,6.71 -3.82,11.48 1.82,5.11 5.32,5.89 9.7,-0.03 0.37,-7.57 -1.61,-12.45 -5.88,-11.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1419.34 2419.96c-0.28,4.04 1.73,7.43 5.14,6.89 4.51,-0.77 6.21,-4.77 4,-12.16 -5.79,-3.08 -8.7,-0.51 -9.14,5.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2248.52 1924.25c4.76,4.41 8.63,4.77 10.65,-0.48 1.52,-3.94 -0.8,-7.34 -3.81,-8.32 -4.35,-1.47 -7.42,0.69 -6.84,8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1768.98 2631.8c-1.02,1.16 -1.49,4.7 -0.85,6.18 2.99,6.98 7.03,6.08 11.52,-0.73 -2.55,-8.4 -6.16,-10.88 -10.67,-5.45z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2542.81 1642.48c-0.02,-0.02 -0.06,-0.03 -0.06,-0.03l-0.04 0.04c0.02,-0.04 0.08,-0.04 0.1,-0.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2542.7 1642.49c-0.21,0.12 -0.49,0.66 0,0l0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2543.58 1625.44c-2.44,-2.06 -5.88,-1.86 -7.86,1.55 -2.8,4.81 -1.03,9.28 1.98,12.68 1.38,1.57 3.46,2 5.02,2.75 0.17,-0.24 0.43,-0.61 0.78,-1.22 3.65,-7.62 4,-12.56 0.08,-15.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2473.64 1122.97c-2.31,5.3 0.82,8.85 6.79,10.28 5.73,-3.74 6.7,-8.4 3.18,-12.13 -3.2,-3.47 -7.95,-2.83 -9.96,1.85z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2525.81 635.95c0.7,-1.39 0.09,-5.06 -0.93,-6.23 -3.81,-4.2 -6.77,-2.25 -8.43,5.05 3.64,6.75 6.93,6.29 9.36,1.17z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2664.2 2436.99c-4.89,-0.73 -6.91,3.66 -7.91,8.59 -0.48,2.19 0.29,4.87 2.01,10.13 7.3,5.13 11.13,2.39 12.72,-4.73 1.45,-6.49 -1.98,-13.27 -6.82,-13.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1409.22 2520.29c-7.35,-0.54 -14.14,-6.89 -15.91,4.79 -1.24,7.85 4.1,9.76 8.45,12.11 1.32,0.71 2.72,1.14 4.78,0.44 -0.1,1.47 -0.17,3.05 -0.25,4.81 -1.05,15.76 -1.88,28.51 -1.3,41.11 0.92,21.3 1.45,42.48 17.5,57.45 7.7,7.2 12.65,19.3 18.95,29.04 3.2,4.75 6.06,11.62 10.15,13.28 10.27,4.07 16.35,14 23.86,22.34 12.75,14.11 25.79,27.91 39.39,40.75 20.92,19.75 45.72,13.5 52.86,-23.7 2.11,-11.17 5.2,-22.17 3.27,-33.82 -1.68,-10.43 0.35,-19.97 2.29,-30 4.83,-24.72 9.34,-49.46 17.05,-73.06 3.85,-12.02 6.21,-24.63 3.95,-37.4 -4.89,-27.5 -12.81,-53.03 -30.55,-72.05 -6.88,-7.49 -14.11,-15.12 -18.86,-24.54 -8.18,-16.01 -20,-20.18 -33.35,-21.73 -21.62,-2.43 -41.29,7.17 -60.96,16.44 -3.59,1.67 -7.84,4.71 -9.66,8.7 -9.97,21.55 -26.81,38.33 -30.84,67.92 -0.22,-0.95 -0.42,-1.88 -0.82,-2.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1888.58 1051.61c-6.46,-0.17 -8.01,4.7 -5.45,13.75 7.36,3.63 10.85,1.14 10.73,-6.87 -0.06,-4.17 -1.99,-6.83 -5.28,-6.88z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1799.15 1452.9c-0.04,0.26 -0.1,0.25 -1.7,2.64 -2.76,4.32 -4.38,6.07 -4.78,8.24 -0.99,4.79 -0.99,9.82 4.03,10.93 5.41,1.3 6.47,-4.21 6.24,-8.7 -0.28,-4.62 -2.43,-8.99 -3.79,-13.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M742.96 890.19c4.08,-2.27 4.33,-6.77 -0.3,-12.13 -5.89,-0.78 -9.64,1.39 -8.64,7.1 0.85,5.01 5.22,7.06 8.94,5.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2446.71 362.25c1.72,-3.07 0.39,-7.18 -2.25,-8.86 -5.33,-3.32 -8.81,-1.16 -8.73,8.56 4.72,4.44 8.56,4.73 10.98,0.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1621.44 847.74c2.33,0.49 5.04,-2.28 7.98,-6.11 -1.82,-4.9 -3.73,-8.52 -6.11,-8.91 -2.19,-0.38 -6.09,1.85 -6.89,4.27 -1.76,5.34 0.91,9.82 5.01,10.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M3143.57 1139.69c0.35,2.2 0.95,4.46 1.73,6.92 4.67,5.79 8.6,9.52 12.88,12.4 27.11,18.35 27.12,18.3 29.84,-26.24 0.54,0.14 1.09,0.36 1.71,0.43 3.44,-4.25 5.72,-6.85 8.38,-8.4 3.83,-2.14 7.64,-4.34 7.27,-10.48 -0.49,-7.29 -4.79,-10.94 -9.89,-12.32 -6.33,-1.66 -8.94,3.74 -10.2,10.4 -0.87,4.45 -1.7,8.81 -4.15,12.69 -1.05,-0.67 -2.24,-1.24 -3.63,-1.87 -7.09,-2.99 -12.12,-4.2 -18.87,-6.07 0.28,-0.28 0.59,-0.54 0.84,-0.86 -5.03,-4.33 -7.45,-1.64 -8.5,2.53 -0.76,0.5 -1.49,1.09 -2.15,1.81 -0.23,-0.09 -0.38,0.43 -1.76,2.2 -0.04,-0.51 -0.02,-0.99 -0.1,-1.51 -8.1,6.6 -8.22,13.45 -3.41,18.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2865.16 1717.71c0,0 -0.01,0.1 -0.01,0.15 0.01,-0.08 0.01,-0.13 0.01,-0.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2864.37 1728.23c1.01,-3.09 0.56,-6.98 0.78,-10.36 -0.07,0.15 -0.35,0.26 -1.75,0.28 -3.79,0.63 -5.8,0.82 -7.36,1.89 -2.68,1.86 -4.01,4.96 -3.08,8.9 0.91,3.64 2.97,6.98 5.94,6.03 2.17,-0.79 4.55,-3.89 5.46,-6.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1830.05 2278.08c0.6,1.6 3.15,3.34 4.37,2.94 4.67,-1.41 5.46,-5.34 1.6,-11.41 -5.88,-0.13 -8.04,2.89 -5.97,8.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2429.45 2382.2c-2.12,3.14 -1.38,7.18 1.27,9.28 4.02,3.12 6.96,0.61 8.42,-6.67 -3.31,-6.49 -6.71,-7.03 -9.69,-2.62z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1459.56 3766.38c3.64,-5.89 3.7,-10.61 0.21,-13.49 -2.4,-2.08 -5.66,-0.58 -6.97,2.73 -2.7,6.75 -0.73,10.95 6.76,10.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1741.58 1389.75c-1.69,4.22 0.56,7.6 3.67,8.53 4.57,1.42 7.51,-1.18 6.95,-9.57 -4.9,-5.12 -8.57,-4.35 -10.62,1.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2676.89 1081.05c-2.34,9.1 -0.24,13.56 6.05,12.2 2.92,-0.64 5.04,-4.32 4.28,-7.93 -1.14,-5.45 -4.74,-6.92 -10.32,-4.27z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1682.85 1484.41c-6.96,-3.25 -10.35,-0.75 -10.31,6.91 0.05,3.86 1.82,7 4.99,7.02 6.42,0.09 7.38,-5.31 5.31,-13.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2768.45 2446.43c0.32,-2.38 -2.04,-7.55 -3.75,-8.03 -6.12,-1.55 -8.11,3.23 -6.16,12.11 5.51,3 9.12,1.3 9.92,-4.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2660.92 2218.48c-2.22,-2.04 -5.12,-2.86 -9.29,-2.54 -2.38,7.64 -0.01,11.39 4.14,12.98 2.84,1.13 6.07,0.25 7.03,-3.77 0.43,-1.91 -0.56,-5.48 -1.88,-6.67z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1534.43 885.55c-0.67,-0.67 -1.43,-1.28 -2.43,-1.76 -6.57,2.3 -11.17,3.68 -15.8,5.25 -5.18,1.73 -8.84,5.31 -7.53,12.86 1.34,7.53 7.47,12.17 13.36,9.24 4,-2.07 7.45,-6.33 12.52,-12.06 0.17,0.86 0.33,1.74 0.59,2.68 2.36,0.75 3.44,0.69 6,-0.78 -0.04,0.43 -0.04,0.89 0.14,1.34 2.46,-1.97 3.51,-3.91 3.53,-5.39 0.62,-0.9 1.19,-1.91 1.81,-3.35 -3.12,-14.36 -3.45,-14.82 -12.19,-8.02z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1537.94 2002.07c0.04,-3.91 -2.15,-5.65 -6.58,-4.4 -2.3,4.85 -1.68,8.03 1.18,9.33 3.1,1.26 5.3,-0.87 5.4,-4.93z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1773.12 2957.19c-3.13,2.45 -2.44,5.98 1.42,9.47 4.79,-1.66 5.86,-4.88 3.51,-8.32 -0.89,-1.29 -3.83,-2 -4.93,-1.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1661.22 2059.17c-5.83,2.89 -6.06,6.88 -2.51,10.61 0.93,0.87 3.93,0.24 4.89,-1.01 2.2,-2.96 1.44,-6.31 -2.38,-9.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2375.77 2180.7c-1.02,1.07 -1.44,4.8 -0.74,6.2 1.88,3.81 4.62,3.67 7.4,-1.57 -1.44,-6.08 -3.97,-7.46 -6.66,-4.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M3280.25 813.64c-3.29,-0.08 -4.64,3.17 -3.73,9.14 4.07,2.87 6.89,2.2 7.97,-1.79 1.11,-4.3 -0.87,-7.26 -4.24,-7.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2885.79 2303.68c-0.94,-0.04 -2.78,3.04 -2.75,4.61 0.07,3.89 2.26,5.75 6.7,4.76 3.05,-7.35 -0.09,-9.13 -3.95,-9.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1588.98 1162.4c-1.3,-0.19 -3.75,1.91 -4.06,3.47 -0.77,4.39 1.36,6.58 6.11,5.61 2.32,-5.33 1.48,-8.63 -2.05,-9.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1363.61 1161.28c1.28,0.16 3.7,-2.02 3.98,-3.66 0.81,-4.36 -1.26,-6.65 -6.09,-5.59 -2.28,5.36 -1.4,8.69 2.11,9.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1630.2 2376.84c0.32,-4.09 -1.05,-7.28 -4.37,-8.1 -5.39,-1.3 -6.62,2.95 -5.24,10.92 5.47,4.2 9.07,4.39 9.61,-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1766.08 2180.9c-2.94,2.35 -2.36,5.76 1.34,9.24 4.68,-1.69 5.55,-4.82 3.39,-8.16 -0.86,-1.21 -3.69,-1.94 -4.73,-1.08z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1069.5 1199.29c0.22,-1.39 -1.67,-4.1 -2.94,-4.55 -3.17,-0.99 -5.17,0.94 -4.11,7.12 3.99,2.63 6.53,1.5 7.05,-2.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M783.87 1510.04c2.57,-6.76 3.07,-11.99 -2.55,-12.97 -3.43,-0.57 -5.57,2.01 -6.22,6 -1.28,7.16 2.72,8.13 8.77,6.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1696.68 1363.1c4.12,-3.82 2.45,-7.95 -2.35,-12.5 -5.51,2.52 -7.66,6.18 -4.75,11.26 1.86,3.33 4.56,3.64 7.1,1.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M3374.2 1675.07c-1.45,-5.57 -3.7,-7.19 -6.34,-4.38 -0.92,0.95 -1.32,4.48 -0.63,5.8 1.74,3.42 4.37,3.39 6.97,-1.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M211.02 3095.15c-2.08,-7.58 -5.11,-9.45 -8.71,-5.01 -0.95,1.31 -1.43,4.85 -0.73,6.36 2.4,5.25 5.78,5.08 9.44,-1.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1406.16 1360.38c-4.35,2.1 -5.08,6 -0.11,10.97 4.45,-1.6 5.94,-4.54 4.55,-8.16 -0.64,-1.56 -3.32,-3.41 -4.44,-2.82z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1820.89 1490.82c0.02,1.74 1.64,4.33 2.96,4.9 4.85,2.18 6.09,-2.33 5.72,-9.03 -4.86,-2.23 -8.83,-2.58 -8.67,4.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2486.16 1620.98c4.55,-1.69 5.57,-4.81 3.4,-8.14 -0.73,-1.17 -3.56,-1.65 -4.6,-0.83 -2.73,2.31 -2.73,5.58 1.2,8.97z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2451.87 1620.88c-0.85,-1.27 -3.67,-1.92 -4.67,-1.05 -2.93,2.38 -2.54,5.71 1.35,9.17 4.71,-1.64 5.41,-4.87 3.32,-8.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2704.23 1792.76c1.18,0.16 3.56,-2.05 3.79,-3.52 0.68,-4.22 -1.45,-6.51 -6.03,-5.65 -1.97,5.25 -1.17,8.6 2.24,9.18z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M767.08 2070.6c3.86,3.18 6.4,2.42 7.36,-1.37 0.99,-3.86 -0.59,-6.89 -3.86,-6.96 -3.07,-0.09 -4.54,2.66 -3.5,8.33z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2279.68 1690.88c-1.14,1.09 -2.21,2.34 -3.42,4.07 -18.83,29.84 -18.62,41.53 -1.37,66.22 5.51,7.84 11.89,12.53 22.43,16.54 -0.54,0.06 -1.15,0.1 -1.69,0.19 7.47,5.1 14.16,10.34 18.7,3.35 2.02,-0.24 4.09,-0.68 6.34,-1.21 11.31,-0.24 17.3,-4.43 17.7,-17.15 0.71,-22.96 -3.79,-43.71 -17.25,-63.57 -0.11,-0.2 -0.26,-0.39 -0.37,-0.58 0.25,-0.12 0.51,-0.15 0.75,-0.23 -0.35,-16.07 1.94,-28.35 6.09,-39.27 1.81,-0.54 3.71,-1.26 5.72,-2.13 6.2,-1.61 10.37,-3.23 16.2,-4.74 -0.08,0.35 -0.17,0.71 -0.21,1.14 3.12,3.84 4.71,6.67 6.62,9.04 1.04,1.38 2.59,2.26 3.97,3.34 0.39,-1.96 1.09,-3.87 1.12,-5.82 0.02,-4.04 -0.21,-8.19 -1.34,-12.59 0.81,-1.04 1.6,-2.24 2.39,-3.66 -0.35,-10.62 -3.31,-18.7 -3.59,-26.92 -0.76,-18.57 -7.5,-32.66 -19.31,-47.07 0.51,-0.07 0.99,-0.09 1.49,-0.21 -7.36,-6.62 -13.35,-16.36 -20.95,-11.94 -2.16,-0.33 -4.43,-0.31 -6.99,0.28 -9.95,4.82 -17.97,8.64 -24.98,15.59 -6.36,6.22 -7.84,13.21 -6.27,22.25 0.9,4.77 2.08,9.46 1.41,15.55 -0.02,0.02 -0.06,0.04 -0.1,0.07 -0.09,-0.17 -0.13,-0.27 -0.22,-0.43 -3.96,1.21 -5.97,1.46 -7.93,1.8 -14.8,1.69 -17.17,4.18 -11.87,18.3 0.07,2.53 0.47,5.37 1.3,8.83 1.41,3.62 2.88,4.96 6.95,7.33 -0.58,0.11 -1.17,0.12 -1.72,0.26 6.52,8.17 12.73,11.61 17.16,4.06 1.88,-0.28 3.85,-0.75 5.98,-1.32 6.34,0.14 10.59,0.39 16.58,3.21 0.15,0.16 0.31,0.25 0.48,0.41 -0.61,0.06 -1.19,0.07 -1.76,0.21 -1.86,12.29 -4.03,21.94 -5.18,32.61 -1.19,0.14 -2.38,0.37 -3.7,0.65 -4.2,-0.55 -6.67,-0.39 -10.73,-0.42 0.19,-0.32 0.44,-0.56 0.64,-0.87 -4.98,-1.01 -8.56,-0.04 -9.05,4.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1009.47 2388.64c-0.93,1.22 -1.25,4.74 -0.55,6.33 2.27,5.36 5.47,5.26 9.1,-1.39 -2.08,-7.3 -4.99,-9.57 -8.55,-4.94z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2134.35 1125.22c-4.54,2.1 -5.36,6.24 -0.16,11.37 4.69,-1.69 6.24,-4.82 4.75,-8.51 -0.64,-1.65 -3.41,-3.45 -4.59,-2.86z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2652.39 1931.72c3.16,0.12 4.62,-2.74 3.46,-8.54 -3.9,-2.96 -6.51,-2.43 -7.52,1.43 -0.97,4.03 0.83,7.01 4.06,7.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2105.93 2505.95c-1.3,-5.74 -3.64,-7.31 -6.32,-4.37 -1.03,1.07 -1.53,4.66 -0.88,6.01 1.84,3.91 4.51,3.03 7.2,-1.63z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2019.16 3050.25c-2.33,6.76 -0.72,9.96 3.84,10.11 0.69,-0.01 1.82,-1.26 2.04,-2.21 1.37,-5.17 0.61,-8.84 -5.88,-7.89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2464.14 952.31c0.07,-1.63 -1.57,-4.58 -2.76,-4.92 -3.35,-1.08 -5.02,1.51 -4.11,7.4 4.06,2.86 6.56,1.91 6.88,-2.48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1729.65 1755.95c3.79,2.95 6.37,2.39 7.28,-1.35 0.95,-3.94 -0.79,-6.9 -3.98,-7.08 -3.15,-0.16 -4.32,2.82 -3.3,8.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1765.98 1189.19c-1.89,-3.68 -4.63,-3.15 -7.35,1.56 1.48,5.72 3.82,7.42 6.57,4.44 0.96,-1 1.44,-4.67 0.78,-6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2378.07 4124.69c-4.7,1.72 -5.54,4.85 -3.4,8.14 0.78,1.28 3.67,1.9 4.72,1.02 2.89,-2.34 2.61,-5.74 -1.31,-9.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2909.28 1411.65c2.36,-5.17 1.24,-8.22 -2.04,-8.82 -1.24,-0.17 -3.62,1.86 -3.84,3.3 -0.73,4.19 1.25,6.45 5.89,5.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2389.45 849.62c2.32,-5.33 1.43,-8.55 -2.08,-9.03 -1.3,-0.14 -3.64,2.08 -3.94,3.68 -0.83,4.31 1.2,6.57 6.01,5.35z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2615.84 2100.63c3.99,3.17 6.82,2.57 7.8,-1.44 1.05,-4.17 -0.91,-7.27 -4.24,-7.42 -3.29,-0.11 -4.73,2.91 -3.55,8.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1464.46 2385.51c-1.25,-6.16 -3.55,-7.34 -6.07,-4.43 -0.89,1.04 -1.13,4.63 -0.43,6.08 1.66,3.53 4.15,3.99 6.5,-1.65z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M3153.93 1305.6c-0.37,-0.82 -3.55,-0.79 -4.37,0.26 -1.87,2.29 -3.01,5.48 -3.78,8.34 0.69,0.08 2.08,0.05 3.65,-0.43 4.11,-2.14 6.27,-4.33 4.49,-8.16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1854.54 3819.06c-2,4.3 -2.42,8.75 1.41,7.23 3.05,-1.22 2.21,-5.34 -1.41,-7.23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1553.87 1172.61c0.93,-1.86 1.88,-3.63 1.99,-6.89 -3.18,-0.81 -4.24,0.98 -3.63,4.01 0.22,1.07 1.1,1.91 1.64,2.87z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2212.7 1354.81l-0.12 0.04c0,0 0.08,0.03 0.12,-0.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2212.6 1354.39c0.11,0.22 0.1,0.34 0.1,0.42 0.15,-0.13 1.11,-0.46 1.11,-0.46 0,0 -1.49,-0.52 -1.21,0.04z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M1424.16 2109.05c0.42,3.74 2.27,6.14 3.4,5.55 3.77,-1.72 2.28,-5.2 0.07,-8.06 -0.82,0.35 -2.46,-0.27 -3.47,2.51z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2801.39 2108.92c0,0 -0.05,0.1 -0.05,0.12 0.11,-0.07 0.11,-0.11 0.05,-0.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FE2643",
    fillRule: "nonzero",
    d: "M2800.75 2109.36c-0.68,0.31 -1.11,2.4 -1.11,2.4 0,0 1.49,-2.43 1.7,-2.72 -0.1,0.07 -0.27,0.19 -0.59,0.32z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderSplashRed1);
export default __webpack_public_path__ + "static/media/loaderSplashRed1.ab1a00975ab9d4a7e28abddc34756cb9.svg";
export { ForwardRef as ReactComponent };